/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import "./Webcard.css";
import ShareButton from "../ShareButton/ShareButton";
import { toast } from "react-toastify";
import AddToHomeScreen from "../AddToHomeButton/AddToHomeButton";
import Modal from "react-bootstrap/Modal";
import defaultProfilePic from "../../../images/default_pfp.svg";
import { useDispatch, useSelector } from "react-redux";
import { realtorWebcardApi } from "../../../Services/Realtor/RealtorApi/RealtorApi";
import { updateProfileApi } from "../../../Services/updateProfile/updateProfileApi";
import { State, City } from "country-state-city";
import environments from "../../../Utils/Environment";
import { useParams } from "react-router-dom";
import ShareButtonPhone from "../ShareButton/ShareButtonPhone";
import CommunitySearch from "./CommunitySearch/CommunitySearch";
import { Box } from "@mui/material";
import { fetchUserType } from "../../../Services/Signup/SignupApi/SignupApi";
import WebCardBottomSection from "../WebCardBottomSection/WebCardBottomSection";
import community_icon from "../../../images/Oscar.svg";
import { getVendorsByType } from "../../../Services/Vendor/VendorApi/VendorApi";
import { ThreeDot } from "react-loading-indicators";
import ReactCrop from "react-easy-crop";

// Add this helper function for creating a cropped image
const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.src = url;
  });

// Add this helper function for getting the cropped canvas
const getCroppedImg = async (imageSrc, pixelCrop) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  // Set canvas size to desired dimensions
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // Create a circular clipping path
  ctx.beginPath();
  ctx.arc(
    canvas.width / 2,
    canvas.height / 2,
    Math.min(canvas.width, canvas.height) / 2,
    0,
    2 * Math.PI,
    true
  );
  ctx.clip();

  // Draw the cropped image
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  // Convert canvas to blob
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    }, "image/jpeg");
  });
};

const Webcard = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [modalShow, setModalShow] = React.useState(false);
  const [isShared, setIsShared] = useState(false);
  const [spmodalShow, setSpmodalShow] = React.useState(false);
  const [isNameEmpty, setIsNameEmpty] = useState(false);
  const userId = localStorage.getItem("user_id");
  const { data: profile, loading } = useSelector(
    (state) => state.realtorWebcard
  );
  const vendors = useSelector((state) => state.getVendorsByType.data);
  const realtorCode = localStorage.getItem("realtor_code");
  const url = `${environments.staging.frontendUrl}realtor/webcard/${realtorCode}`;

  useEffect(() => {
    const currentPage = window.location.pathname;
    localStorage.setItem("lastVisitedPage", currentPage);
    localStorage.setItem("webcard_code", currentPage.split("/").pop());
  }, []);

  useEffect(() => {
    // Check if all vendors have an empty name
    const allNamesEmpty = vendors?.vendor?.every(
      (vendor) => vendor.name === "" || vendor.name === null
    );

    // Set the state accordingly
    setIsNameEmpty(allNamesEmpty);
  }, [vendors?.vendor]);

  useEffect(() => {
    if (id) setIsShared(true);
    else setIsShared(false);
  }, [id]);

  useEffect(() => {
    dispatch(
      getVendorsByType({
        vendor_master_name: "community_expert",
        realtor_code: id,
        user_id: userId,
      })
    );
  }, [dispatch, id, userId]);

  useEffect(() => {
    if (realtorCode) {
      dispatch(realtorWebcardApi(realtorCode)); // Fetch profile data
    }
    if (id) {
      dispatch(realtorWebcardApi(id)); // Fetch profile data
    }
  }, [dispatch, id, realtorCode]);

  if (loading)
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "75vh",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <ThreeDot color="#e55426" size="small" text="" textColor="" />
        </Box>
      </div>
    );

  return (
    <div>
      <div className="community-section webcard-section">
        {!isShared ? (
          <div className="add-new-community d-flex justify-content-between align-items-center">
            <div className="community-heading">WebCard</div>
            <div className="d-flex gap-2">
              <button
                className="orange-filled-btn addcommunitybtn"
                onClick={() =>
                  window.open(url, "_blank", "noopener,noreferrer")
                }
              >
                View
              </button>
              <button
                className="orange-filled-btn addcommunitybtn"
                onClick={() => setModalShow(true)}
              >
                Edit
              </button>
            </div>
          </div>
        ) : null}
        <div className="community-inner">
          <div className="all-commmunities-table mt-0 d-flex">
            <div className="responsive-block-webcard">
              <div className="responsive-inner d-flex justify-content-between align-items-center w-100">
                <div className="webcard-logo-image">
                  <img src={profile?.brokerage_logo} alt="Logo"></img>
                </div>
                <div className="d-flex gap-2">
                  <div className="resp-share-btn">
                    <ShareButton url={url} />
                  </div>
                  <AddToHomeScreen />
                </div>
              </div>
            </div>
            <div className="webcard-block-one d-flex align-items-center">
              <div className="webcard-img-name-blk d-flex gap-4 align-items-center flex-grow-1">
                <div className="webcard-img">
                  <img
                    src={profile?.image || defaultProfilePic}
                    alt="img"
                    className="rounded-circle"
                  ></img>
                </div>
                <div className="tab-group">
                  <div className="community-expert-block">
                    <h4 className="person-name">
                      {profile?.first_name} {profile?.last_name}
                    </h4>
                    <div className="tab-group icon-mob">
                      <div className="community-expert-block">
                        <div className="contact-icons d-flex flex-column align-items-center">
                          <div className="small-icon-blk icon-web flex-column">
                            <div className="phone-no vendor-tab">
                              <a href={`tel:${profile?.phone_number}`}>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.26036 10.6357C4.83848 12.5222 6.73818 14.0075 8.90644 15.0584C9.73197 15.4496 10.836 15.9138 12.066 15.9934C12.1422 15.9967 12.2152 16 12.2914 16C13.117 16 13.78 15.7149 14.3204 15.1281C14.3238 15.1247 14.3304 15.1181 14.3337 15.1115C14.526 14.8794 14.7448 14.6705 14.9736 14.4484C15.1294 14.2992 15.2885 14.1434 15.441 13.9843C16.1472 13.2482 16.1472 12.3133 15.4344 11.6005L13.4419 9.60796C13.1037 9.25653 12.6992 9.07087 12.2749 9.07087C11.8505 9.07087 11.4427 9.25653 11.0946 9.60464L9.90768 10.7915C9.79828 10.7286 9.68555 10.6722 9.57946 10.6191C9.44685 10.5528 9.32418 10.4898 9.21477 10.4202C8.13396 9.73394 7.15261 8.83879 6.21436 7.68835C5.74026 7.08827 5.42198 6.58433 5.19985 6.07045C5.5115 5.78864 5.80325 5.49358 6.08506 5.20514C6.18452 5.10236 6.28729 4.99959 6.39007 4.89681C6.74813 4.53875 6.94042 4.12433 6.94042 3.70327C6.94042 3.28222 6.75145 2.8678 6.39007 2.50974L5.40209 1.52176C5.28605 1.40572 5.17664 1.293 5.06392 1.17696C4.84511 0.951513 4.61634 0.719436 4.3909 0.510568C4.04942 0.175715 3.64826 0 3.22389 0C2.80284 0 2.39836 0.175715 2.04361 0.513883L0.803664 1.75383C0.352773 2.20472 0.0974891 2.75176 0.0444431 3.385C-0.0185491 4.17737 0.127327 5.01948 0.50528 6.0373C1.08547 7.6121 1.96073 9.07418 3.26036 10.6357ZM0.853395 3.45462C0.893179 3.01368 1.06226 2.64567 1.38054 2.32739L2.61386 1.09407C2.80615 0.908413 3.01833 0.812267 3.22389 0.812267C3.42613 0.812267 3.63168 0.908413 3.82066 1.1007C4.04279 1.30626 4.25165 1.52176 4.4771 1.75052C4.58982 1.86656 4.70586 1.98259 4.8219 2.10195L5.80988 3.08993C6.01543 3.29548 6.12153 3.50435 6.12153 3.7099C6.12153 3.91546 6.01543 4.12433 5.80988 4.32988C5.7071 4.43266 5.60433 4.53875 5.50155 4.64152C5.19322 4.95317 4.90478 5.24824 4.58651 5.53005L4.56993 5.54662C4.29475 5.8218 4.33785 6.08371 4.40416 6.28264C4.40748 6.29258 4.41079 6.29921 4.41411 6.30916C4.66939 6.9225 5.02414 7.50601 5.5778 8.20224C6.57242 9.42893 7.62007 10.3804 8.77383 11.1131C8.91639 11.206 9.06889 11.2789 9.21145 11.3518C9.34407 11.4182 9.46674 11.4811 9.57615 11.5508C9.58941 11.5574 9.59935 11.564 9.61261 11.5707C9.72202 11.627 9.82811 11.6535 9.93421 11.6535C10.1994 11.6535 10.3718 11.4845 10.4282 11.4281L11.6681 10.1881C11.8604 9.99586 12.0693 9.89308 12.2749 9.89308C12.5268 9.89308 12.7324 10.0489 12.8617 10.1881L14.8609 12.184C15.2587 12.5818 15.2554 13.0128 14.8509 13.4339C14.7117 13.5831 14.5658 13.7257 14.41 13.8748C14.1779 14.1003 13.9359 14.3324 13.717 14.5943C13.3358 15.0054 12.8816 15.1977 12.2948 15.1977C12.2384 15.1977 12.1787 15.1944 12.1224 15.191C11.0349 15.1214 10.0237 14.6971 9.2645 14.3357C7.20234 13.3378 5.39214 11.9221 3.89028 10.1252C2.65364 8.63655 1.82148 7.25072 1.27113 5.76544C0.929648 4.85371 0.800349 4.12101 0.853395 3.45462Z"
                                    fill="#414141"
                                  />
                                </svg>
                              </a>
                            </div>
                            <div className="msgs vendor-tab">
                              <a href={`mailto:${profile?.email}`}>
                                <svg
                                  width="16"
                                  height="12"
                                  viewBox="0 0 16 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M15.1795 0.666504H0.820531C0.369219 0.666504 0 1.03572 0 1.487V10.5127C0 10.9639 0.369219 11.3332 0.820531 11.3332H15.1795C15.6307 11.3332 16 10.964 16 10.5127V1.487C16 1.03572 15.6308 0.666504 15.1795 0.666504ZM14.8716 1.28185L8.472 6.08191C8.35694 6.16947 8.18031 6.22425 7.99997 6.22344C7.81966 6.22425 7.64306 6.16947 7.52797 6.08191L1.12841 1.28185H14.8716ZM11.4531 6.39863L14.9403 10.7063C14.9438 10.7107 14.9481 10.7139 14.9518 10.7178H1.04819C1.05187 10.7138 1.05619 10.7107 1.05969 10.7063L4.54688 6.39863C4.5723 6.36721 4.59129 6.33109 4.60275 6.29233C4.61422 6.25356 4.61793 6.21292 4.61368 6.17273C4.60943 6.13253 4.5973 6.09357 4.57799 6.05806C4.55868 6.02255 4.53256 5.9912 4.50112 5.96579C4.36903 5.85894 4.17537 5.87919 4.0685 6.01132L0.615375 10.277V1.66647L7.15894 6.57416C7.40491 6.75735 7.70416 6.83797 7.99994 6.83879C8.29531 6.83816 8.59481 6.75753 8.84094 6.57416L15.3845 1.66647V10.2769L11.9315 6.01132C11.8246 5.87922 11.6308 5.85891 11.4988 5.96579C11.3665 6.07263 11.3462 6.26653 11.4531 6.39863Z"
                                    fill="#414141"
                                  />
                                </svg>
                              </a>
                            </div>
                            <div className="globe vendor-tab">
                              <a
                                href={profile?.real_estate_website_url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8 0C4.62047 0 0 2.55433 0 8C0 13.3071 4.44409 16 8 16C14.1008 16 16 10.6551 16 8C16 4.08189 13.0016 0 8 0ZM6.14488 0.752756C5.31024 1.46457 4.61732 2.64252 4.17008 4.10394C3.59055 3.76063 3.05827 3.33543 2.58583 2.84094C3.5622 1.81732 4.79685 1.09921 6.14488 0.752756ZM2.24252 3.2252C2.77165 3.77638 3.37323 4.24567 4.02835 4.61732C3.78268 5.57165 3.6378 6.62992 3.6189 7.74173H0.522835C0.579528 6.08189 1.18425 4.49764 2.24252 3.2252ZM2.24252 12.7748C1.1811 11.5024 0.579528 9.91811 0.522835 8.25827H3.6189C3.6378 9.37323 3.78268 10.4283 4.02835 11.3827C3.37638 11.7575 2.7748 12.2236 2.24252 12.7748ZM2.58583 13.1622C3.05827 12.6677 3.59055 12.2425 4.17008 11.8992C4.61732 13.3575 5.31024 14.5386 6.14488 15.2504C4.79685 14.9008 3.5622 14.1827 2.58583 13.1622ZM7.74173 15.4646C6.4 15.2945 5.24409 13.7953 4.62047 11.6472C5.58425 11.1591 6.64882 10.885 7.74173 10.8441V15.4646ZM7.74173 10.3307C6.60157 10.3685 5.49291 10.6488 4.48819 11.1402C4.27717 10.2583 4.15118 9.28504 4.13228 8.25827H7.74173V10.3307ZM7.74173 7.74173H4.13228C4.15118 6.71496 4.27717 5.74173 4.48819 4.85984C5.49606 5.35118 6.60472 5.6315 7.74173 5.66929V7.74173ZM7.74173 5.15591C6.64567 5.11811 5.58425 4.84094 4.62047 4.35276C5.24409 2.20157 6.4 0.705512 7.74173 0.535433V5.15591ZM13.7575 3.2252C14.8157 4.49764 15.4205 6.08189 15.4772 7.74173H12.3843C12.3654 6.62677 12.2205 5.57165 11.9748 4.61732C12.6268 4.24252 13.2283 3.77638 13.7575 3.2252ZM13.4142 2.8378C12.9417 3.33228 12.4094 3.75748 11.8299 4.10079C11.3827 2.64252 10.6898 1.46457 9.85512 0.749606C11.2031 1.09921 12.4378 1.81732 13.4142 2.8378ZM8.25827 0.535433C9.6 0.705512 10.7559 2.20472 11.3795 4.35276C10.4157 4.84094 9.35433 5.11496 8.25827 5.15591V0.535433ZM8.25827 5.66929C9.39843 5.6315 10.5071 5.35118 11.5118 4.85984C11.7228 5.74173 11.8488 6.71496 11.8677 7.74173H8.25827V5.66929ZM8.25827 8.25827H11.8677C11.8488 9.28504 11.7228 10.2583 11.5118 11.1402C10.4976 10.6411 9.38815 10.365 8.25827 10.3307V8.25827ZM8.25827 15.4646V10.8441C9.35433 10.8819 10.4157 11.1591 11.3795 11.6472C10.7559 13.7984 9.6 15.2945 8.25827 15.4646ZM9.85512 15.2472C10.6898 14.5354 11.3827 13.3575 11.8299 11.8961C12.4094 12.2394 12.9417 12.6646 13.4142 13.1591C12.4378 14.1827 11.2031 14.9008 9.85512 15.2472ZM13.7575 12.7748C13.2283 12.2236 12.6268 11.7575 11.9748 11.3827C12.2205 10.4283 12.3654 9.37008 12.3843 8.25827H15.4772C15.4205 9.91811 14.8157 11.5024 13.7575 12.7748Z"
                                    fill="#414141"
                                  />
                                </svg>
                              </a>
                            </div>
                            <ShareButtonPhone url={url} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <p className="expert-address expert-address-webc mb-0">
                      {profile?.address}
                    </p>
                    <p className="expert-address expert-address-webc mb-0">
                      {profile?.bldg_suite_unit}
                    </p>
                    <p className="expert-address expert-address-webc mb-0">
                      {profile?.city}, {profile?.state} {profile?.zipcode}{" "}
                    </p>
                    <p className="expert-address expert-address-webc mb-0">
                      {profile?.phone_number} | {profile?.email}
                    </p>
                  </div>
                </div>
              </div>
              <div className="tab-group icon-web">
                <div className="community-expert-block">
                  <div className="contact-icons d-flex flex-column align-items-center">
                    <div className="small-icon-blk icon-web flex-column">
                      <div className="phone-no vendor-tab">
                        <a href={`tel:${profile?.phone_number}`}>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.26036 10.6357C4.83848 12.5222 6.73818 14.0075 8.90644 15.0584C9.73197 15.4496 10.836 15.9138 12.066 15.9934C12.1422 15.9967 12.2152 16 12.2914 16C13.117 16 13.78 15.7149 14.3204 15.1281C14.3238 15.1247 14.3304 15.1181 14.3337 15.1115C14.526 14.8794 14.7448 14.6705 14.9736 14.4484C15.1294 14.2992 15.2885 14.1434 15.441 13.9843C16.1472 13.2482 16.1472 12.3133 15.4344 11.6005L13.4419 9.60796C13.1037 9.25653 12.6992 9.07087 12.2749 9.07087C11.8505 9.07087 11.4427 9.25653 11.0946 9.60464L9.90768 10.7915C9.79828 10.7286 9.68555 10.6722 9.57946 10.6191C9.44685 10.5528 9.32418 10.4898 9.21477 10.4202C8.13396 9.73394 7.15261 8.83879 6.21436 7.68835C5.74026 7.08827 5.42198 6.58433 5.19985 6.07045C5.5115 5.78864 5.80325 5.49358 6.08506 5.20514C6.18452 5.10236 6.28729 4.99959 6.39007 4.89681C6.74813 4.53875 6.94042 4.12433 6.94042 3.70327C6.94042 3.28222 6.75145 2.8678 6.39007 2.50974L5.40209 1.52176C5.28605 1.40572 5.17664 1.293 5.06392 1.17696C4.84511 0.951513 4.61634 0.719436 4.3909 0.510568C4.04942 0.175715 3.64826 0 3.22389 0C2.80284 0 2.39836 0.175715 2.04361 0.513883L0.803664 1.75383C0.352773 2.20472 0.0974891 2.75176 0.0444431 3.385C-0.0185491 4.17737 0.127327 5.01948 0.50528 6.0373C1.08547 7.6121 1.96073 9.07418 3.26036 10.6357ZM0.853395 3.45462C0.893179 3.01368 1.06226 2.64567 1.38054 2.32739L2.61386 1.09407C2.80615 0.908413 3.01833 0.812267 3.22389 0.812267C3.42613 0.812267 3.63168 0.908413 3.82066 1.1007C4.04279 1.30626 4.25165 1.52176 4.4771 1.75052C4.58982 1.86656 4.70586 1.98259 4.8219 2.10195L5.80988 3.08993C6.01543 3.29548 6.12153 3.50435 6.12153 3.7099C6.12153 3.91546 6.01543 4.12433 5.80988 4.32988C5.7071 4.43266 5.60433 4.53875 5.50155 4.64152C5.19322 4.95317 4.90478 5.24824 4.58651 5.53005L4.56993 5.54662C4.29475 5.8218 4.33785 6.08371 4.40416 6.28264C4.40748 6.29258 4.41079 6.29921 4.41411 6.30916C4.66939 6.9225 5.02414 7.50601 5.5778 8.20224C6.57242 9.42893 7.62007 10.3804 8.77383 11.1131C8.91639 11.206 9.06889 11.2789 9.21145 11.3518C9.34407 11.4182 9.46674 11.4811 9.57615 11.5508C9.58941 11.5574 9.59935 11.564 9.61261 11.5707C9.72202 11.627 9.82811 11.6535 9.93421 11.6535C10.1994 11.6535 10.3718 11.4845 10.4282 11.4281L11.6681 10.1881C11.8604 9.99586 12.0693 9.89308 12.2749 9.89308C12.5268 9.89308 12.7324 10.0489 12.8617 10.1881L14.8609 12.184C15.2587 12.5818 15.2554 13.0128 14.8509 13.4339C14.7117 13.5831 14.5658 13.7257 14.41 13.8748C14.1779 14.1003 13.9359 14.3324 13.717 14.5943C13.3358 15.0054 12.8816 15.1977 12.2948 15.1977C12.2384 15.1977 12.1787 15.1944 12.1224 15.191C11.0349 15.1214 10.0237 14.6971 9.2645 14.3357C7.20234 13.3378 5.39214 11.9221 3.89028 10.1252C2.65364 8.63655 1.82148 7.25072 1.27113 5.76544C0.929648 4.85371 0.800349 4.12101 0.853395 3.45462Z"
                              fill="#414141"
                            />
                          </svg>
                        </a>
                      </div>
                      <div className="msgs vendor-tab">
                        <a href={`mailto:${profile?.email}`}>
                          <svg
                            width="16"
                            height="12"
                            viewBox="0 0 16 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.1795 0.666504H0.820531C0.369219 0.666504 0 1.03572 0 1.487V10.5127C0 10.9639 0.369219 11.3332 0.820531 11.3332H15.1795C15.6307 11.3332 16 10.964 16 10.5127V1.487C16 1.03572 15.6308 0.666504 15.1795 0.666504ZM14.8716 1.28185L8.472 6.08191C8.35694 6.16947 8.18031 6.22425 7.99997 6.22344C7.81966 6.22425 7.64306 6.16947 7.52797 6.08191L1.12841 1.28185H14.8716ZM11.4531 6.39863L14.9403 10.7063C14.9438 10.7107 14.9481 10.7139 14.9518 10.7178H1.04819C1.05187 10.7138 1.05619 10.7107 1.05969 10.7063L4.54688 6.39863C4.5723 6.36721 4.59129 6.33109 4.60275 6.29233C4.61422 6.25356 4.61793 6.21292 4.61368 6.17273C4.60943 6.13253 4.5973 6.09357 4.57799 6.05806C4.55868 6.02255 4.53256 5.9912 4.50112 5.96579C4.36903 5.85894 4.17537 5.87919 4.0685 6.01132L0.615375 10.277V1.66647L7.15894 6.57416C7.40491 6.75735 7.70416 6.83797 7.99994 6.83879C8.29531 6.83816 8.59481 6.75753 8.84094 6.57416L15.3845 1.66647V10.2769L11.9315 6.01132C11.8246 5.87922 11.6308 5.85891 11.4988 5.96579C11.3665 6.07263 11.3462 6.26653 11.4531 6.39863Z"
                              fill="#414141"
                            />
                          </svg>
                        </a>
                      </div>
                      <div className="globe vendor-tab">
                        <a
                          href={profile?.real_estate_website_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 0C4.62047 0 0 2.55433 0 8C0 13.3071 4.44409 16 8 16C14.1008 16 16 10.6551 16 8C16 4.08189 13.0016 0 8 0ZM6.14488 0.752756C5.31024 1.46457 4.61732 2.64252 4.17008 4.10394C3.59055 3.76063 3.05827 3.33543 2.58583 2.84094C3.5622 1.81732 4.79685 1.09921 6.14488 0.752756ZM2.24252 3.2252C2.77165 3.77638 3.37323 4.24567 4.02835 4.61732C3.78268 5.57165 3.6378 6.62992 3.6189 7.74173H0.522835C0.579528 6.08189 1.18425 4.49764 2.24252 3.2252ZM2.24252 12.7748C1.1811 11.5024 0.579528 9.91811 0.522835 8.25827H3.6189C3.6378 9.37323 3.78268 10.4283 4.02835 11.3827C3.37638 11.7575 2.7748 12.2236 2.24252 12.7748ZM2.58583 13.1622C3.05827 12.6677 3.59055 12.2425 4.17008 11.8992C4.61732 13.3575 5.31024 14.5386 6.14488 15.2504C4.79685 14.9008 3.5622 14.1827 2.58583 13.1622ZM7.74173 15.4646C6.4 15.2945 5.24409 13.7953 4.62047 11.6472C5.58425 11.1591 6.64882 10.885 7.74173 10.8441V15.4646ZM7.74173 10.3307C6.60157 10.3685 5.49291 10.6488 4.48819 11.1402C4.27717 10.2583 4.15118 9.28504 4.13228 8.25827H7.74173V10.3307ZM7.74173 7.74173H4.13228C4.15118 6.71496 4.27717 5.74173 4.48819 4.85984C5.49606 5.35118 6.60472 5.6315 7.74173 5.66929V7.74173ZM7.74173 5.15591C6.64567 5.11811 5.58425 4.84094 4.62047 4.35276C5.24409 2.20157 6.4 0.705512 7.74173 0.535433V5.15591ZM13.7575 3.2252C14.8157 4.49764 15.4205 6.08189 15.4772 7.74173H12.3843C12.3654 6.62677 12.2205 5.57165 11.9748 4.61732C12.6268 4.24252 13.2283 3.77638 13.7575 3.2252ZM13.4142 2.8378C12.9417 3.33228 12.4094 3.75748 11.8299 4.10079C11.3827 2.64252 10.6898 1.46457 9.85512 0.749606C11.2031 1.09921 12.4378 1.81732 13.4142 2.8378ZM8.25827 0.535433C9.6 0.705512 10.7559 2.20472 11.3795 4.35276C10.4157 4.84094 9.35433 5.11496 8.25827 5.15591V0.535433ZM8.25827 5.66929C9.39843 5.6315 10.5071 5.35118 11.5118 4.85984C11.7228 5.74173 11.8488 6.71496 11.8677 7.74173H8.25827V5.66929ZM8.25827 8.25827H11.8677C11.8488 9.28504 11.7228 10.2583 11.5118 11.1402C10.4976 10.6411 9.38815 10.365 8.25827 10.3307V8.25827ZM8.25827 15.4646V10.8441C9.35433 10.8819 10.4157 11.1591 11.3795 11.6472C10.7559 13.7984 9.6 15.2945 8.25827 15.4646ZM9.85512 15.2472C10.6898 14.5354 11.3827 13.3575 11.8299 11.8961C12.4094 12.2394 12.9417 12.6646 13.4142 13.1591C12.4378 14.1827 11.2031 14.9008 9.85512 15.2472ZM13.7575 12.7748C13.2283 12.2236 12.6268 11.7575 11.9748 11.3827C12.2205 10.4283 12.3654 9.37008 12.3843 8.25827H15.4772C15.4205 9.91811 14.8157 11.5024 13.7575 12.7748Z"
                              fill="#414141"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hz-line-block"></div>
            <div className="webcard-logo-block">
              <div className="logo-share-blk gap-2 d-flex flex-column">
                <div className="webcard-logo-image">
                  <img src={profile?.brokerage_logo} alt="Logo"></img>
                </div>
                <div>
                  {/* <button className="orange-filled-btn claimbtn "><span className='me-2'><svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.307 10.7623C10.5404 10.7623 9.8497 11.0934 9.37036 11.62L5.05871 8.94958C5.17708 8.64698 5.23777 8.32491 5.23765 7.99998C5.23779 7.67506 5.1771 7.35298 5.05871 7.05039L9.37036 4.37987C9.84973 4.90649 10.5404 5.23768 11.307 5.23768C12.7511 5.23768 13.9259 4.06287 13.9259 2.61878C13.9259 1.17469 12.7511 0 11.307 0C9.86292 0 8.68811 1.17481 8.68811 2.6189C8.68805 2.94381 8.74873 3.26586 8.86705 3.56846L4.55552 6.23889C4.07615 5.71227 3.38549 5.38108 2.6189 5.38108C1.17481 5.38108 0 6.55602 0 7.99998C0 9.44404 1.17481 10.6189 2.6189 10.6189C3.38546 10.6189 4.07618 10.2878 4.55552 9.76108L8.86708 12.4315C8.74874 12.7341 8.68804 13.0562 8.68811 13.3812C8.68811 14.8252 9.86289 16 11.307 16C12.7511 16 13.9259 14.8252 13.9259 13.3812C13.9259 11.9371 12.7511 10.7623 11.307 10.7623ZM9.64304 2.6189C9.64304 1.7014 10.3895 0.954967 11.307 0.954967C12.2244 0.954967 12.9709 1.7014 12.9709 2.6189C12.9709 3.5364 12.2245 4.28284 11.307 4.28284C10.3895 4.28284 9.64304 3.53637 9.64304 2.6189ZM2.6189 9.66392C1.70128 9.66392 0.954842 8.91745 0.954842 7.99998C0.954842 7.08252 1.70128 6.33605 2.6189 6.33605C3.5364 6.33605 4.28271 7.08252 4.28271 7.99998C4.28271 8.91745 3.53637 9.66392 2.6189 9.66392ZM9.64304 13.3811C9.64304 12.4636 10.3895 11.7171 11.307 11.7171C12.2244 11.7171 12.9709 12.4636 12.9709 13.3811C12.9709 14.2986 12.2245 15.045 11.307 15.045C10.3895 15.045 9.64304 14.2986 9.64304 13.3811V13.3811Z" fill="white" />
                                    </svg>
                                    </span>Share</button> */}
                  <ShareButton url={url} />
                </div>
              </div>
            </div>
          </div>
          <div className="ai-powered-block">
            <CommunitySearch realtorCode={id || realtorCode} />
          </div>
          <div className="community-resources d-flex align-items-center w-100 flex-wrap">
            <a
              className="resources-inner d-flex align-items-center"
              href={profile?.real_estate_website_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="resources-img">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 512 512"
                  fill="black"
                >
                  <g>
                    <path d="M434.929 46.131C424.549 35.729 410.745 30 396.058 30H371.25v-5c0-13.785-11.215-25-25-25h-180c-13.785 0-25 11.215-25 25v5h-24.897c-30.261 0-54.908 24.646-54.942 54.939l-.411 372c-.016 14.702 5.691 28.528 16.07 38.93C87.45 506.271 101.255 512 115.942 512h279.704c30.262 0 54.909-24.646 54.942-54.939l.412-372c.017-14.703-5.691-28.529-16.071-38.93zM171.25 30h170v30h-170zm249.37 427.027C420.604 470.798 409.401 482 395.646 482H115.942c-6.676 0-12.951-2.604-17.669-7.332-4.718-4.729-7.312-11.013-7.305-17.695l.411-372C91.394 71.202 102.597 60 116.353 60h24.897v5c0 13.785 11.215 25 25 25h180c13.785 0 25-11.215 25-25v-5h24.808c6.676 0 12.951 2.604 17.669 7.332s7.313 11.013 7.305 17.695z" />
                    <path d="M261.099 200H367.67c8.284 0 15-6.716 15-15s-6.716-15-15-15H261.099c-8.284 0-15 6.716-15 15s6.716 15 15 15zM261.099 300H367.67c8.284 0 15-6.716 15-15s-6.716-15-15-15H261.099c-8.284 0-15 6.716-15 15s6.716 15 15 15zM368.099 370h-107c-8.284 0-15 6.716-15 15s6.716 15 15 15h107c8.284 0 15-6.716 15-15s-6.715-15-15-15zM197.256 144.157l-34.592 34.592-8.156-8.157c-5.858-5.858-15.355-5.858-21.213 0-5.858 5.857-5.858 15.355 0 21.213l18.763 18.764a15 15 0 0 0 21.213 0l45.199-45.198c5.858-5.857 5.858-15.355 0-21.213-5.858-5.859-15.355-5.859-21.214-.001zM197.256 251.794l-34.592 34.592-8.156-8.156c-5.858-5.858-15.355-5.858-21.213 0-5.858 5.857-5.858 15.354 0 21.213l18.763 18.764a15 15 0 0 0 21.213 0l45.199-45.199c5.858-5.857 5.858-15.355 0-21.213s-15.356-5.858-21.214-.001zM197.256 351.794l-34.592 34.592-8.156-8.156c-5.858-5.858-15.355-5.858-21.213 0-5.858 5.857-5.858 15.354 0 21.213l18.763 18.764a15 15 0 0 0 21.213 0l45.199-45.199c5.858-5.857 5.858-15.355 0-21.213s-15.356-5.858-21.214-.001z" />
                  </g>
                </svg>
              </div>
              <div>Find a home</div>
            </a>
            {profile?.about_me_url ? (
              <a
                className={`resources-inner d-flex align-items-center ${
                  !profile?.about_me_url ? "no-hover" : ""
                }`}
                href={profile?.about_me_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="resources-img">
                  <svg
                    width="24"
                    height="18"
                    viewBox="0 0 24 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.5 18H2.5C1.8372 17.9992 1.20178 17.7356 0.73311 17.2669C0.264441 16.7982 0.000793929 16.1628 0 15.5L0 2.5C0 1.122 1.122 0 2.5 0H21.5C22.878 0 24 1.122 24 2.5V15.5C24 16.878 22.878 18 21.5 18ZM2.5 1C1.673 1 1 1.673 1 2.5V15.5C1 16.327 1.673 17 2.5 17H21.5C22.327 17 23 16.327 23 15.5V2.5C23 1.673 22.327 1 21.5 1H2.5Z"
                      fill="#414141"
                    />
                    <path
                      d="M7.5 9C6.122 9 5 7.878 5 6.5C5 5.122 6.122 4 7.5 4C8.878 4 10 5.122 10 6.5C10 7.878 8.878 9 7.5 9ZM7.5 5C6.673 5 6 5.673 6 6.5C6 7.327 6.673 8 7.5 8C8.327 8 9 7.327 9 6.5C9 5.673 8.327 5 7.5 5ZM11.5 14C11.3674 14 11.2402 13.9473 11.1464 13.8536C11.0527 13.7598 11 13.6326 11 13.5V12.5C11 11.673 10.327 11 9.5 11H5.5C4.673 11 4 11.673 4 12.5V13.5C4 13.6326 3.94732 13.7598 3.85355 13.8536C3.75979 13.9473 3.63261 14 3.5 14C3.36739 14 3.24021 13.9473 3.14645 13.8536C3.05268 13.7598 3 13.6326 3 13.5V12.5C3 11.122 4.122 10 5.5 10H9.5C10.878 10 12 11.122 12 12.5V13.5C12 13.6326 11.9473 13.7598 11.8536 13.8536C11.7598 13.9473 11.6326 14 11.5 14ZM20.5 6H14.5C14.3674 6 14.2402 5.94732 14.1464 5.85355C14.0527 5.75979 14 5.63261 14 5.5C14 5.36739 14.0527 5.24021 14.1464 5.14645C14.2402 5.05268 14.3674 5 14.5 5H20.5C20.6326 5 20.7598 5.05268 20.8536 5.14645C20.9473 5.24021 21 5.36739 21 5.5C21 5.63261 20.9473 5.75979 20.8536 5.85355C20.7598 5.94732 20.6326 6 20.5 6ZM20.5 10H14.5C14.3674 10 14.2402 9.94732 14.1464 9.85355C14.0527 9.75979 14 9.63261 14 9.5C14 9.36739 14.0527 9.24021 14.1464 9.14645C14.2402 9.05268 14.3674 9 14.5 9H20.5C20.6326 9 20.7598 9.05268 20.8536 9.14645C20.9473 9.24021 21 9.36739 21 9.5C21 9.63261 20.9473 9.75979 20.8536 9.85355C20.7598 9.94732 20.6326 10 20.5 10ZM20.5 14H14.5C14.3674 14 14.2402 13.9473 14.1464 13.8536C14.0527 13.7598 14 13.6326 14 13.5C14 13.3674 14.0527 13.2402 14.1464 13.1464C14.2402 13.0527 14.3674 13 14.5 13H20.5C20.6326 13 20.7598 13.0527 20.8536 13.1464C20.9473 13.2402 21 13.3674 21 13.5C21 13.6326 20.9473 13.7598 20.8536 13.8536C20.7598 13.9473 20.6326 14 20.5 14Z"
                      fill="#414141"
                    />
                  </svg>
                </div>
                <div>About me</div>
              </a>
            ) : null}
            {!isNameEmpty ? (
              <a
                className="resources-inner d-flex align-items-center"
                onClick={() => {
                  if (!isNameEmpty) setSpmodalShow(true);
                }}
                style={{ pointerEvents: isNameEmpty ? "none" : "auto" }}
              >
                <div className="resources-img">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.6 23.2H21.2V10C21.2 9.89391 21.1579 9.79217 21.0828 9.71716C21.0078 9.64214 20.9061 9.6 20.8 9.6H15.2V0.4C15.2 0.293913 15.1579 0.192172 15.0828 0.117157C15.0078 0.0421427 14.9061 0 14.8 0L4.4 0C4.29391 0 4.19217 0.0421427 4.11716 0.117157C4.04214 0.192172 4 0.293913 4 0.4V23.2H0.4C0.293913 23.2 0.192172 23.2421 0.117157 23.3172C0.0421427 23.3922 0 23.4939 0 23.6C0 23.7061 0.0421427 23.8078 0.117157 23.8828C0.192172 23.9579 0.293913 24 0.4 24H23.6C23.7061 24 23.8078 23.9579 23.8828 23.8828C23.9579 23.8078 24 23.7061 24 23.6C24 23.4939 23.9579 23.3922 23.8828 23.3172C23.8078 23.2421 23.7061 23.2 23.6 23.2ZM8.4 23.2H6.8V19.6C6.8 19.4939 6.84214 19.3922 6.91716 19.3172C6.99217 19.2421 7.09391 19.2 7.2 19.2H8C8.10609 19.2 8.20783 19.2421 8.28284 19.3172C8.35786 19.3922 8.4 19.4939 8.4 19.6V23.2ZM10 10V23.2H9.2V19.6C9.2 18.9373 8.66275 18.4 8 18.4H7.2C6.53725 18.4 6 18.9373 6 19.6V23.2H4.8V0.8H14.4V9.6H10.4C10.2939 9.6 10.1922 9.64214 10.1172 9.71716C10.0421 9.79217 10 9.89391 10 10ZM20.4 23.2H10.8V10.4H20.4V23.2Z"
                      fill="#414141"
                    />
                    <path
                      d="M12.8 5.59998H10.4C10.2939 5.59998 10.1922 5.64212 10.1172 5.71713C10.0421 5.79215 10 5.89389 10 5.99998V8.39998C10 8.50606 10.0421 8.6078 10.1172 8.68282C10.1922 8.75783 10.2939 8.79998 10.4 8.79998H12.8C12.9061 8.79998 13.0078 8.75783 13.0828 8.68282C13.1579 8.6078 13.2 8.50606 13.2 8.39998V5.99998C13.2 5.89389 13.1579 5.79215 13.0828 5.71713C13.0078 5.64212 12.9061 5.59998 12.8 5.59998ZM12.4 7.99998H10.8V6.39998H12.4V7.99998ZM12.8 1.59998H10.4C10.2939 1.59998 10.1922 1.64212 10.1172 1.71713C10.0421 1.79215 10 1.89389 10 1.99998V4.39998C10 4.50606 10.0421 4.6078 10.1172 4.68282C10.1922 4.75783 10.2939 4.79998 10.4 4.79998H12.8C12.9061 4.79998 13.0078 4.75783 13.0828 4.68282C13.1579 4.6078 13.2 4.50606 13.2 4.39998V1.99998C13.2 1.89389 13.1579 1.79215 13.0828 1.71713C13.0078 1.64212 12.9061 1.59998 12.8 1.59998ZM12.4 3.99998H10.8V2.39998H12.4V3.99998ZM8.8 5.59998H6.4C6.29391 5.59998 6.19217 5.64212 6.11716 5.71713C6.04214 5.79215 6 5.89389 6 5.99998V8.39998C6 8.50606 6.04214 8.6078 6.11716 8.68282C6.19217 8.75783 6.29391 8.79998 6.4 8.79998H8.8C8.90609 8.79998 9.00783 8.75783 9.08284 8.68282C9.15786 8.6078 9.2 8.50606 9.2 8.39998V5.99998C9.2 5.89389 9.15786 5.79215 9.08284 5.71713C9.00783 5.64212 8.90609 5.59998 8.8 5.59998ZM8.4 7.99998H6.8V6.39998H8.4V7.99998ZM8.8 1.59998H6.4C6.29391 1.59998 6.19217 1.64212 6.11716 1.71713C6.04214 1.79215 6 1.89389 6 1.99998V4.39998C6 4.50606 6.04214 4.6078 6.11716 4.68282C6.19217 4.75783 6.29391 4.79998 6.4 4.79998H8.8C8.90609 4.79998 9.00783 4.75783 9.08284 4.68282C9.15786 4.6078 9.2 4.50606 9.2 4.39998V1.99998C9.2 1.89389 9.15786 1.79215 9.08284 1.71713C9.00783 1.64212 8.90609 1.59998 8.8 1.59998ZM8.4 3.99998H6.8V2.39998H8.4V3.99998ZM8.8 9.59998H6.4C6.29391 9.59998 6.19217 9.64212 6.11716 9.71713C6.04214 9.79215 6 9.89389 6 9.99998V12.4C6 12.5061 6.04214 12.6078 6.11716 12.6828C6.19217 12.7578 6.29391 12.8 6.4 12.8H8.8C8.90609 12.8 9.00783 12.7578 9.08284 12.6828C9.15786 12.6078 9.2 12.5061 9.2 12.4V9.99998C9.2 9.89389 9.15786 9.79215 9.08284 9.71713C9.00783 9.64212 8.90609 9.59998 8.8 9.59998ZM8.4 12H6.8V10.4H8.4V12ZM8.8 13.6H6.4C6.29391 13.6 6.19217 13.6421 6.11716 13.7171C6.04214 13.7921 6 13.8939 6 14V16.4C6 16.5061 6.04214 16.6078 6.11716 16.6828C6.19217 16.7578 6.29391 16.8 6.4 16.8H8.8C8.90609 16.8 9.00783 16.7578 9.08284 16.6828C9.15786 16.6078 9.2 16.5061 9.2 16.4V14C9.2 13.8939 9.15786 13.7921 9.08284 13.7171C9.00783 13.6421 8.90609 13.6 8.8 13.6ZM8.4 16H6.8V14.4H8.4V16ZM16.4 18.4H18.8C18.9061 18.4 19.0078 18.3578 19.0828 18.2828C19.1579 18.2078 19.2 18.1061 19.2 18V15.6C19.2 15.4939 19.1579 15.3921 19.0828 15.3171C19.0078 15.2421 18.9061 15.2 18.8 15.2H16.4C16.2939 15.2 16.1922 15.2421 16.1172 15.3171C16.0421 15.3921 16 15.4939 16 15.6V18C16 18.1061 16.0421 18.2078 16.1172 18.2828C16.1922 18.3578 16.2939 18.4 16.4 18.4ZM16.8 16H18.4V17.6H16.8V16ZM16.4 14.4H18.8C18.9061 14.4 19.0078 14.3578 19.0828 14.2828C19.1579 14.2078 19.2 14.1061 19.2 14V11.6C19.2 11.4939 19.1579 11.3921 19.0828 11.3171C19.0078 11.2421 18.9061 11.2 18.8 11.2H16.4C16.2939 11.2 16.1922 11.2421 16.1172 11.3171C16.0421 11.3921 16 11.4939 16 11.6V14C16 14.1061 16.0421 14.2078 16.1172 14.2828C16.1922 14.3578 16.2939 14.4 16.4 14.4ZM16.8 12H18.4V13.6H16.8V12ZM16.4 22.4H18.8C18.9061 22.4 19.0078 22.3578 19.0828 22.2828C19.1579 22.2078 19.2 22.1061 19.2 22V19.6C19.2 19.4939 19.1579 19.3921 19.0828 19.3171C19.0078 19.2421 18.9061 19.2 18.8 19.2H16.4C16.2939 19.2 16.1922 19.2421 16.1172 19.3171C16.0421 19.3921 16 19.4939 16 19.6V22C16 22.1061 16.0421 22.2078 16.1172 22.2828C16.1922 22.3578 16.2939 22.4 16.4 22.4ZM16.8 20H18.4V21.6H16.8V20ZM12.4 18.4H14.8C14.9061 18.4 15.0078 18.3578 15.0828 18.2828C15.1579 18.2078 15.2 18.1061 15.2 18V15.6C15.2 15.4939 15.1579 15.3921 15.0828 15.3171C15.0078 15.2421 14.9061 15.2 14.8 15.2H12.4C12.2939 15.2 12.1922 15.2421 12.1172 15.3171C12.0421 15.3921 12 15.4939 12 15.6V18C12 18.1061 12.0421 18.2078 12.1172 18.2828C12.1922 18.3578 12.2939 18.4 12.4 18.4ZM12.8 16H14.4V17.6H12.8V16ZM12.4 14.4H14.8C14.9061 14.4 15.0078 14.3578 15.0828 14.2828C15.1579 14.2078 15.2 14.1061 15.2 14V11.6C15.2 11.4939 15.1579 11.3921 15.0828 11.3171C15.0078 11.2421 14.9061 11.2 14.8 11.2H12.4C12.2939 11.2 12.1922 11.2421 12.1172 11.3171C12.0421 11.3921 12 11.4939 12 11.6V14C12 14.1061 12.0421 14.2078 12.1172 14.2828C12.1922 14.3578 12.2939 14.4 12.4 14.4ZM12.8 12H14.4V13.6H12.8V12ZM12.4 22.4H14.8C14.9061 22.4 15.0078 22.3578 15.0828 22.2828C15.1579 22.2078 15.2 22.1061 15.2 22V19.6C15.2 19.4939 15.1579 19.3921 15.0828 19.3171C15.0078 19.2421 14.9061 19.2 14.8 19.2H12.4C12.2939 19.2 12.1922 19.2421 12.1172 19.3171C12.0421 19.3921 12 19.4939 12 19.6V22C12 22.1061 12.0421 22.2078 12.1172 22.2828C12.1922 22.3578 12.2939 22.4 12.4 22.4ZM12.8 20H14.4V21.6H12.8V20Z"
                      fill="#414141"
                    />
                  </svg>
                </div>
                <div>Real estate service providers</div>
              </a>
            ) : null}
            <a
              className="resources-inner d-flex align-items-center"
              href="https://www.mortgagecalculator.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="resources-img">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_737_488)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.20077 2.79997H8.80075C9.02165 2.79997 9.20074 2.62089 9.20074 2.39999C9.20074 2.17909 9.02165 2 8.80075 2H7.20077C6.97987 2 6.80078 2.17909 6.80078 2.39999C6.80078 2.62089 6.97987 2.79997 7.20077 2.79997Z"
                      fill="#30303"
                    />
                    <path
                      d="M2.3991 11.5873V15.2001C2.3991 15.8628 2.93636 16.4001 3.5991 16.4001H9.19911C9.86185 16.4001 10.3991 15.8628 10.3991 15.2001V11.5881C10.5961 11.5606 10.7757 11.4608 10.9031 11.3081L11.4159 10.6889C11.4832 10.6076 11.5337 10.5137 11.5645 10.4127C11.5952 10.3117 11.6056 10.2056 11.5951 10.1006C11.5845 9.99551 11.5532 9.89362 11.5029 9.80078C11.4527 9.70793 11.3845 9.62599 11.3023 9.55971L10.3991 8.83012V6.80011C10.3991 6.35828 10.0409 6.0001 9.5991 6.0001H8.79909C8.35725 6.0001 7.99907 6.35828 7.99907 6.80011V6.88972L6.90706 6.00652C6.76299 5.8909 6.58379 5.82788 6.39907 5.82788C6.21434 5.82788 6.03514 5.8909 5.89107 6.00652L1.49629 9.56006C1.41407 9.62631 1.34583 9.70822 1.29553 9.80105C1.24522 9.89389 1.21386 9.99579 1.20325 10.1008C1.19265 10.2059 1.20301 10.312 1.23374 10.413C1.26447 10.514 1.31496 10.6079 1.38228 10.6893L1.8951 11.3085C2.0228 11.4606 2.20238 11.5599 2.3991 11.5873ZM5.59911 15.6001V13.6C5.59911 13.3791 5.7782 13.2001 5.9991 13.2001H6.79911C7.02001 13.2001 7.1991 13.3791 7.1991 13.6V15.6001H5.59911ZM9.19911 15.6001H7.99911V13.6C7.99911 12.9373 7.46185 12.4 6.79911 12.4H5.9991C5.33636 12.4 4.7991 12.9373 4.7991 13.6V15.6001H3.5991C3.3782 15.6001 3.19911 15.421 3.19911 15.2001V11.2801L6.39912 8.7421L9.59914 11.2801V15.2001C9.5991 15.421 9.42001 15.6001 9.19911 15.6001ZM8.79909 6.80007H9.5991V8.18326L8.79909 7.53647V6.80007ZM6.40389 6.62846L10.7991 10.1793L10.2871 10.8001C10.2858 10.8009 10.2843 10.8013 10.2827 10.8013C10.2811 10.8013 10.2796 10.8009 10.2783 10.8001L10.2723 10.796L6.6479 7.92004C6.57715 7.86384 6.48946 7.83326 6.39911 7.83326C6.30875 7.83326 6.22106 7.86384 6.15031 7.92004L2.5115 10.8L1.99911 10.1824L6.40389 6.62846Z"
                      fill="#303030"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.7996 17.2001H1.9996C1.7787 17.2001 1.59961 17.3792 1.59961 17.6001C1.59961 17.821 1.7787 18 1.9996 18H10.7996C11.0205 18 11.1996 17.821 11.1996 17.6001C11.1996 17.3791 11.0205 17.2001 10.7996 17.2001ZM6.39957 19.6001C6.62047 19.6001 6.79956 19.421 6.79956 19.2001C6.79956 18.9792 6.62047 18.8001 6.39957 18.8001H1.9996C1.7787 18.8001 1.59961 18.9792 1.59961 19.2001C1.59961 19.421 1.7787 19.6001 1.9996 19.6001H6.39957Z"
                      fill="#303030"
                    />
                    <path
                      d="M22.8 8.00001H17.6V5.20003C17.6 4.53729 17.0627 4.00003 16.4 4.00003H16V3.60004C16 2.93731 15.4628 2.40004 14.8 2.40004H13.1264C13.044 2.16688 12.8915 1.96488 12.6899 1.82168C12.4883 1.67847 12.2473 1.60106 12 1.60003H11.6V1.20004C11.6 0.537266 11.0627 0 10.4 0H5.60001C4.93728 0 4.40001 0.537266 4.40001 1.2V1.59999H4.00003C3.75272 1.60101 3.51177 1.67843 3.31014 1.82163C3.10851 1.96483 2.95604 2.16683 2.87361 2.4H1.2C0.537266 2.4 0 2.93727 0 3.6V21.2C0 21.8627 0.537266 22.4 1.2 22.4H1.59999V22.8C1.59999 23.4627 2.13725 24 2.79999 24H22.8C23.4627 24 24 23.4627 24 22.8V9.20001C24 8.53728 23.4627 8.00001 22.8 8.00001ZM16.4 4.8C16.6209 4.8 16.8 4.97909 16.8 5.19999V7.99997H16V4.79996H16.4V4.8ZM3.99999 2.4H4.8C5.0209 2.4 5.19999 2.22091 5.19999 2.00001V1.2C5.19999 0.979102 5.37908 0.800013 5.59997 0.800013H10.4C10.6209 0.800013 10.8 0.979102 10.8 1.2V2.00001C10.8 2.22091 10.979 2.4 11.1999 2.4H12C12.2209 2.4 12.3999 2.57909 12.3999 2.79999V3.99999H3.6V2.79999C3.6 2.57909 3.77909 2.4 3.99999 2.4ZM0.800013 21.2V3.6C0.800013 3.3791 0.979102 3.20001 1.2 3.20001H2.79999V4.00003C2.79999 4.44186 3.15816 4.80004 3.6 4.80004H12.4C12.8418 4.80004 13.2 4.44186 13.2 4.00003V3.20001H14.8C15.0209 3.20001 15.2 3.3791 15.2 3.6V8.00001H13.2C12.5372 8.00001 12 8.53728 12 9.20001V21.6H1.2C0.979102 21.6 0.800013 21.4209 0.800013 21.2ZM2.4 22.8V22.4H12V22.8C12.0013 22.9366 12.0262 23.0719 12.0736 23.2H2.79999C2.57909 23.2 2.4 23.0209 2.4 22.8ZM23.2 22.8C23.2 23.0209 23.0209 23.2 22.8 23.2H13.2C12.9791 23.2 12.8 23.0209 12.8 22.8V9.20001C12.8 8.97911 12.9791 8.80003 13.2 8.80003H22.8C23.0209 8.80003 23.2 8.97911 23.2 9.20001L23.2 22.8Z"
                      fill="#303030"
                    />
                    <path
                      d="M21.9996 9.59998H13.9996C13.7787 9.59998 13.5996 9.77906 13.5996 9.99996V12.4C13.5996 12.6209 13.7787 12.7999 13.9996 12.7999H21.9996C22.2205 12.7999 22.3996 12.6209 22.3996 12.4V9.99996C22.3996 9.77906 22.2205 9.59998 21.9996 9.59998ZM21.5996 12H14.3996V10.4H21.5996V12ZM15.1996 13.6H14.3996C13.9578 13.6 13.5996 13.9581 13.5996 14.4V15.2C13.5996 15.6418 13.9578 16 14.3996 16H15.1996C15.6415 16 15.9996 15.6418 15.9996 15.2V14.4C15.9996 13.9581 15.6415 13.6 15.1996 13.6ZM14.3996 15.2V14.4H15.1996V15.2H14.3996ZM15.1996 16.8H14.3996C13.9578 16.8 13.5996 17.1582 13.5996 17.6V18.4C13.5996 18.8418 13.9578 19.2 14.3996 19.2H15.1996C15.6415 19.2 15.9996 18.8418 15.9996 18.4V17.6C15.9996 17.1582 15.6415 16.8 15.1996 16.8ZM14.3996 18.4V17.6H15.1996V18.4H14.3996ZM15.1996 20H14.3996C13.9578 20 13.5996 20.3582 13.5996 20.8V21.6C13.5996 22.0418 13.9578 22.4 14.3996 22.4H15.1996C15.6415 22.4 15.9996 22.0418 15.9996 21.6V20.8C15.9996 20.3582 15.6415 20 15.1996 20ZM14.3996 21.6V20.8H15.1996V21.6H14.3996ZM18.3996 13.6H17.5996C17.1578 13.6 16.7996 13.9581 16.7996 14.4V15.2C16.7996 15.6418 17.1578 16 17.5996 16H18.3996C18.8415 16 19.1997 15.6418 19.1997 15.2V14.4C19.1996 13.9581 18.8414 13.6 18.3996 13.6ZM17.5996 15.2V14.4H18.3996V15.2H17.5996ZM18.3996 16.8H17.5996C17.1578 16.8 16.7996 17.1582 16.7996 17.6V18.4C16.7996 18.8418 17.1578 19.2 17.5996 19.2H18.3996C18.8415 19.2 19.1997 18.8418 19.1997 18.4V17.6C19.1996 17.1582 18.8414 16.8 18.3996 16.8ZM17.5996 18.4V17.6H18.3996V18.4H17.5996ZM18.3996 20H17.5996C17.1578 20 16.7996 20.3582 16.7996 20.8V21.6C16.7996 22.0418 17.1578 22.4 17.5996 22.4H18.3996C18.8415 22.4 19.1997 22.0418 19.1997 21.6V20.8C19.1996 20.3582 18.8414 20 18.3996 20ZM17.5996 21.6V20.8H18.3996V21.6H17.5996ZM21.5996 13.6H20.7996C20.3578 13.6 19.9996 13.9581 19.9996 14.4V15.2C19.9996 15.6418 20.3578 16 20.7996 16H21.5996C22.0415 16 22.3996 15.6418 22.3996 15.2V14.4C22.3996 13.9581 22.0415 13.6 21.5996 13.6ZM20.7996 15.2V14.4H21.5997V15.2H20.7996ZM21.5996 16.8H20.7996C20.3578 16.8 19.9996 17.1582 19.9996 17.6V21.6C19.9996 22.0418 20.3578 22.4 20.7996 22.4H21.5996C22.0415 22.4 22.3996 22.0418 22.3996 21.6V17.6C22.3996 17.1582 22.0415 16.8 21.5996 16.8ZM20.7996 21.6V17.6H21.5997V21.6H20.7996Z"
                      fill="#303030"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_737_488">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div>Mortgage Calculator</div>
            </a>
          </div>
          {(profile?.youtube_profile_url ||
            profile?.facebook_profile_url ||
            profile?.instagram_profile_url ||
            profile?.tiktok_profile_url ||
            profile?.linkedin_profile_url ||
            profile?.twitter_profile_url) && (
            <div className="social-media-block d-flex align-items-center justify-content-between">
              <div className="follow-us">
                Follow us for the latest updates, news, and exclusive content!
              </div>
              <div className="socialmedia-box d-flex align-items-center">
                {profile?.youtube_profile_url && (
                  <a
                    href={profile?.youtube_profile_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div
                      className={`media-names d-flex gap-2 align-items-center justify-content-center ${
                        !profile?.youtube_profile_url ? "no-hover" : ""
                      }`}
                    >
                      <div className="media-svgs">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.332 13.936L13.6605 12.005L10.332 10.0645V13.936Z"
                            fill="#414141"
                          />
                          <path
                            d="M12 0C9.62663 0 7.30655 0.703787 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.40779C0.00519938 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693604 16.6688 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C24 8.8174 22.7357 5.76515 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM18.3158 14.1237C18.316 14.4375 18.2544 14.7483 18.1344 15.0384C18.0144 15.3284 17.8385 15.5919 17.6166 15.8139C17.3948 16.0359 17.1314 16.212 16.8414 16.3322C16.5515 16.4524 16.2407 16.5142 15.9268 16.5142H8.07316C7.75931 16.5142 7.44853 16.4524 7.15858 16.3322C6.86864 16.212 6.60522 16.0359 6.38336 15.8139C6.16151 15.5919 5.98557 15.3284 5.86561 15.0384C5.74564 14.7483 5.68401 14.4375 5.68421 14.1237V9.87631C5.68401 9.56246 5.74564 9.25164 5.86561 8.96162C5.98557 8.67159 6.16151 8.40805 6.38336 8.18605C6.60522 7.96405 6.86864 7.78794 7.15858 7.66778C7.44853 7.54763 7.75931 7.48579 8.07316 7.48579H15.9268C16.2407 7.48579 16.5515 7.54763 16.8414 7.66778C17.1314 7.78794 17.3948 7.96405 17.6166 8.18605C17.8385 8.40805 18.0144 8.67159 18.1344 8.96162C18.2544 9.25164 18.316 9.56246 18.3158 9.87631V14.1237Z"
                            fill="#414141"
                          />
                        </svg>
                      </div>
                      <div className="soc-media-name">Youtube</div>
                    </div>
                  </a>
                )}
                {profile?.facebook_profile_url && (
                  <a
                    href={profile?.facebook_profile_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div
                      className={`media-names d-flex gap-2 align-items-center justify-content-center ${
                        !profile?.facebook_profile_url ? "no-hover" : ""
                      }`}
                    >
                      <div className="media-svgs">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_750_625)">
                            <path
                              d="M12 0C5.38323 0 0 5.38323 0 12C0 18.6163 5.38323 24 12 24C18.6163 24 24 18.6163 24 12C24 5.38323 18.6173 0 12 0ZM14.9843 12.4225H13.032V19.381H10.139V12.4225H8.76388V9.9631H10.139V8.37235C10.139 7.23306 10.6804 5.45283 13.0586 5.45283L15.2023 5.46105V7.84838H13.6463C13.3931 7.84838 13.0329 7.97503 13.0329 8.51833V9.96359H15.2371L14.9843 12.4225Z"
                              fill="#414141"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_750_625">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className="soc-media-name">Facebook</div>
                    </div>{" "}
                  </a>
                )}
                {profile?.instagram_profile_url && (
                  <a
                    href={profile?.instagram_profile_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div
                      className={`media-names d-flex gap-2 align-items-center justify-content-center ${
                        !profile?.instagram_profile_url && "no-hover"
                      }`}
                    >
                      <div className="media-svgs">
                        <svg
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_750_618)">
                            <path
                              d="M12.5 14.4609C13.8591 14.4609 14.9609 13.3591 14.9609 12C14.9609 10.6409 13.8591 9.53906 12.5 9.53906C11.1409 9.53906 10.0391 10.6409 10.0391 12C10.0391 13.3591 11.1409 14.4609 12.5 14.4609Z"
                              fill="#6C6C6C"
                            />
                            <path
                              d="M12.5 0.28125C6.02792 0.28125 0.78125 5.52792 0.78125 12C0.78125 18.4721 6.02792 23.7188 12.5 23.7188C18.9721 23.7188 24.2188 18.4721 24.2188 12C24.2188 5.52792 18.9721 0.28125 12.5 0.28125ZM19.7402 14.9784C19.684 16.0926 19.3709 17.1912 18.559 17.9945C17.7392 18.8055 16.6353 19.1076 15.5105 19.1633H9.48959C8.36459 19.1076 7.26087 18.8056 6.44108 17.9945C5.62911 17.1912 5.31608 16.0926 5.25983 14.9784V9.02156C5.31608 7.90744 5.62916 6.80878 6.44108 6.00544C7.26087 5.1945 8.36473 4.89234 9.48959 4.8367H15.5104C16.6354 4.89234 17.7391 5.19436 18.5589 6.00544C19.3709 6.80878 19.6839 7.90744 19.7402 9.02156L19.7402 14.9784Z"
                              fill="#414141"
                            />
                            <path
                              d="M15.4357 6.19423C13.9692 6.15401 11.0339 6.15401 9.56734 6.19423C8.80417 6.21518 7.939 6.40516 7.39525 6.98595C6.83021 7.58965 6.6167 8.31902 6.59504 9.13498C6.55698 10.5671 6.59504 14.8655 6.59504 14.8655C6.61984 15.6814 6.83021 16.4109 7.39525 17.0146C7.939 17.5955 8.80417 17.7853 9.56734 17.8063C11.0339 17.8465 13.9692 17.8465 15.4357 17.8063C16.1989 17.7853 17.0641 17.5954 17.6078 17.0146C18.1728 16.4109 18.3864 15.6815 18.408 14.8655V9.13498C18.3864 8.31902 18.1728 7.58965 17.6078 6.98595C17.0639 6.40498 16.1987 6.21518 15.4357 6.19423ZM12.5013 15.8147C11.7469 15.8147 11.0094 15.591 10.3821 15.1719C9.75486 14.7527 9.26595 14.157 8.97724 13.46C8.68854 12.763 8.613 11.996 8.76018 11.2561C8.90736 10.5162 9.27065 9.83649 9.80411 9.30303C10.3376 8.76957 11.0172 8.40628 11.7572 8.2591C12.4971 8.11192 13.2641 8.18746 13.9611 8.47616C14.6581 8.76487 15.2538 9.25378 15.6729 9.88106C16.0921 10.5083 16.3158 11.2458 16.3158 12.0003C16.3158 13.0119 15.9139 13.9821 15.1986 14.6975C14.4832 15.4128 13.513 15.8147 12.5013 15.8147ZM16.332 8.97316C16.1811 8.97313 16.0337 8.92835 15.9082 8.8445C15.7828 8.76065 15.685 8.64149 15.6273 8.50209C15.5696 8.36269 15.5545 8.2093 15.584 8.06133C15.6134 7.91335 15.6861 7.77744 15.7928 7.67076C15.8995 7.56409 16.0355 7.49145 16.1834 7.46203C16.3314 7.43261 16.4848 7.44773 16.6242 7.50547C16.7636 7.56322 16.8827 7.661 16.9665 7.78645C17.0504 7.91191 17.0951 8.0594 17.0951 8.21027C17.0951 8.31047 17.0753 8.40969 17.037 8.50226C16.9986 8.59483 16.9424 8.67894 16.8716 8.74978C16.8007 8.82063 16.7166 8.87682 16.624 8.91515C16.5314 8.95347 16.4322 8.97319 16.332 8.97316Z"
                              fill="#414141"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_750_618">
                              <rect
                                width="24"
                                height="24"
                                fill="white"
                                transform="translate(0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className="soc-media-name">Instagram</div>
                    </div>{" "}
                  </a>
                )}
                {profile?.tiktok_profile_url && (
                  <a
                    href={profile?.tiktok_profile_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div
                      className={`media-names d-flex gap-2 align-items-center justify-content-center ${
                        !profile?.tiktok_profile_url && "no-hover"
                      }`}
                    >
                      <div className="media-svgs">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="24"
                          height="24"
                          viewBox="0 0 512 512"
                          className=""
                        >
                          <g>
                            <path
                              d="M256 0C114.637 0 0 114.637 0 256s114.637 256 256 256 256-114.637 256-256S397.363 0 256 0zm128.43 195.873v34.663c-16.345.006-32.226-3.197-47.204-9.516a120.587 120.587 0 0 1-26.811-15.636l.246 106.693c-.103 24.025-9.608 46.598-26.811 63.601-14 13.84-31.74 22.641-50.968 25.49a93.951 93.951 0 0 1-13.766 1.012c-20.583 0-40.124-6.668-56.109-18.97a93.08 93.08 0 0 1-8.624-7.532c-18.644-18.427-28.258-43.401-26.639-69.674 1.235-19.999 9.242-39.072 22.59-54.021 17.66-19.782 42.366-30.762 68.782-30.762 4.65 0 9.248.349 13.766 1.018v48.468a43.401 43.401 0 0 0-13.623-2.19c-24.134 0-43.659 19.69-43.298 43.842.229 15.453 8.67 28.961 21.12 36.407a43.023 43.023 0 0 0 19.765 6.062 43.42 43.42 0 0 0 16.036-2.127c17.243-5.696 29.682-21.892 29.682-40.994l.057-71.447V109.82h47.736a74.25 74.25 0 0 0 1.418 13.817c3.603 18.101 13.806 33.805 28.006 44.511 12.382 9.339 27.8 14.875 44.511 14.875.011 0 .149 0 .137-.011v12.861z"
                              fill="#414141"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="soc-media-name">TikTok</div>
                    </div>{" "}
                  </a>
                )}
                {profile?.linkedin_profile_url && (
                  <a
                    href={profile?.linkedin_profile_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div
                      className={`media-names d-flex gap-2 align-items-center justify-content-center ${
                        !profile?.linkedin_profile_url && "no-hover"
                      }`}
                    >
                      <div className="media-svgs">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="24"
                          height="24"
                          viewBox="0 0 512 512"
                          xmlSpace="preserve"
                          className=""
                        >
                          <g>
                            <path
                              d="M256 0C114.637 0 0 114.637 0 256s114.637 256 256 256 256-114.637 256-256S397.363 0 256 0zm-74.39 387h-62.348V199.426h62.347zm-31.173-213.188h-.406c-20.922 0-34.453-14.402-34.453-32.402 0-18.406 13.945-32.41 35.274-32.41 21.328 0 34.453 14.004 34.859 32.41 0 18-13.531 32.403-35.274 32.403zM406.423 387h-62.34V286.652c0-25.218-9.027-42.418-31.586-42.418-17.223 0-27.48 11.602-31.988 22.801-1.649 4.008-2.051 9.61-2.051 15.215V387h-62.344s.817-169.977 0-187.574h62.344v26.558c8.285-12.78 23.11-30.96 56.188-30.96 41.02 0 71.777 26.808 71.777 84.421zm0 0"
                              fill="#414141"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="soc-media-name">LinkedIn</div>
                    </div>{" "}
                  </a>
                )}
                {profile?.twitter_profile_url && (
                  <a
                    href={profile?.twitter_profile_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div
                      className={`media-names d-flex gap-2 align-items-center justify-content-center ${
                        !profile?.twitter_profile_url && "no-hover"
                      }`}
                    >
                      <div className="media-svgs">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="24"
                          height="24"
                          x="0"
                          y="0"
                          viewBox="0 0 1227 1227"
                          style={{
                            enableBackground: "new 0 0 512 512",
                            borderRadius: "30%",
                          }}
                          xmlSpace="preserve"
                        >
                          <g>
                            <path
                              d="M654.53 592.55 930.65 987.5H817.33L592.01 665.22v-.02l-33.08-47.31-263.21-376.5h113.32l212.41 303.85z"
                              fill="#414141"
                              opacity="1"
                            />
                            <path
                              d="M1094.42 0H132.58C59.36 0 0 59.36 0 132.58v961.84C0 1167.64 59.36 1227 132.58 1227h961.84c73.22 0 132.58-59.36 132.58-132.58V132.58C1227 59.36 1167.64 0 1094.42 0zm-311.8 1040.52L554.61 708.68l-285.47 331.84h-73.78l326.49-379.5-326.49-475.17h249.02l215.91 314.23 270.32-314.23h73.78l-311.33 361.9h-.02l338.6 492.77z"
                              fill="#414141"
                              opacity="1"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="soc-media-name">X</div>
                    </div>{" "}
                  </a>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {isShared && <WebCardBottomSection />}
      <EditWebCardModal show={modalShow} onHide={() => setModalShow(false)} />
      <ServiceProvidersModal
        show={spmodalShow}
        onHide={() => setSpmodalShow(false)}
      />
    </div>
  );
};

function EditWebCardModal(props) {
  const dispatch = useDispatch();
  const [profilePic, setProfilePic] = useState(defaultProfilePic);
  const [imageFile, setImageFile] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [logo, setLogo] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [isLogoClicked, setIsLogoClicked] = useState(false);
  const [errors, setErrors] = useState({});
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const { data: roleData } = useSelector((state) => state.fetchUserType);
  const [roleId, setRoleId] = useState("");
  const realtorCode = localStorage.getItem("realtor_code");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: profile } = useSelector((state) => state.realtorWebcard);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    state: "",
    city: "",
    zipcode: "",
    profileImage: null,
    brokerageName: "",
    brokerageLogo: null,
    real_estate_website_url: "",
    instagram: profile?.instagram_profile_url || "",
    youtube: profile?.youtube_profile_url || "",
    facebook: profile?.facebook_profile_url || "",
    about_me: profile?.about_me_url || "",
    tiktok: profile?.tiktok_profile_url || "",
    linkedin: profile?.linkedin_profile_url || "",
    twitter: profile?.twitter_profile_url || "",
  });
  const [showCropModal, setShowCropModal] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const handleCloseCropModal = () => {
    setShowCropModal(false);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
  };

  useEffect(() => {
    dispatch(fetchUserType());
  }, [dispatch]);

  useEffect(() => {
    setRoleId(roleData?.data?.find((role) => role.role_name === "Realtor")?.id);
  }, [roleData?.data]);

  useEffect(() => {
    if (profile) {
      setFormData({
        firstName: profile.first_name || "",
        lastName: profile.last_name || "",
        phoneNumber: profile.phone_number || "",
        image: profile.image || null,
        address: profile.address || "",
        state: profile.state || "",
        city: profile.city || "",
        zipcode: profile.zipcode || "",
        brokerageName: profile.brokerage_name || "",
        brokerageLogo: profile.brokerage_logo || null,
        real_estate_website_url: profile.real_estate_website_url || "",
        instagram: profile.instagram_profile_url || "",
        youtube: profile.youtube_profile_url || "",
        facebook: profile.facebook_profile_url || "",
        about_me: profile?.about_me_url || "",
        tiktok: profile?.tiktok_profile_url || "",
        linkedin: profile?.linkedin_profile_url || "",
        twitter: profile?.twitter_profile_url || "",
      });
    }
  }, [profile, roleId]);

  const validateField = (name, value) => {
    const isEmpty = (val) => !val;
    const isShort = (val, minLength) => val.length < minLength;
    const isInvalidFormat = (val, regex) => !regex.test(val);

    const validationRules = {
      firstName: () => {
        if (isEmpty(value)) return "First name is required";
        if (isShort(value, 2))
          return "First name must be at least 2 characters";
      },
      lastName: () => {
        if (isEmpty(value)) return "Last name is required";
        if (isShort(value, 2)) return "Last name must be at least 2 characters";
      },
      phoneNumber: () => {
        if (isEmpty(value)) return "Phone number is required";
        if (isInvalidFormat(value, /^\(\d{3}\) \d{3}-\d{4}$/))
          return "Phone Number must be in the format (123) 456-7890";
      },
      state: () => {
        if (isEmpty(value)) return "State is required";
      },
      address: () => {
        if (isEmpty(value)) return "Address is required";
      },
      zipcode: () => {
        if (isEmpty(value)) return "Zipcode is required";
        if (isInvalidFormat(value, /^\d{5}(-\d{4})?$/))
          return "Invalid Zipcode format";
      },
      real_estate_website_url: () => {
        if (
          value &&
          isInvalidFormat(
            value,
            /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/.*)?$/
          )
        )
          return "Invalid website URL";
      },
    };

    return validationRules[name]?.() || "";
  };

  useEffect(() => {
    const usaStates = State.getStatesOfCountry("US");
    setStates(usaStates);
  }, []);

  const handleStateChange = (e) => {
    const selectedState = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      state: selectedState,
      city: "",
    }));

    const stateCities = City.getCitiesOfState("US", selectedState);
    setCities(stateCities);

    setErrors((prevErrors) => ({
      ...prevErrors,
      state: "",
      city: "",
    }));
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      city: selectedCity,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      city: "",
    }));
  };

  const handleChange = (event) => {
    const { name, value, files } = event.target;
    const fieldValue = files ? files[0] : value;

    // Update formData
    setFormData((prevData) => ({
      ...prevData,
      [name]: fieldValue,
    }));

    // Validate the field and update errors
    const error = validateField(name, fieldValue);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handlePhoneNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    const { name } = e.target;

    if (value.length > 3 && value.length <= 6) {
      value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
    } else if (value.length > 6) {
      value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(
        6,
        10
      )}`;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const updateProfilePic = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePic(reader.result);
        setIsClicked(true);
        setImageFile(file);
        setShowCropModal(true);
      };
      reader.readAsDataURL(file); // This reads file as base64
    }
  };

  const updateLogo = (event) => {
    const file = event.target.files[0];
    const readerLogo = new FileReader();

    readerLogo.onloadend = () => {
      setLogo(readerLogo.result);
      setIsLogoClicked(true);
      setLogoFile(file);
    };

    if (file) {
      readerLogo.readAsDataURL(file);
    }
  };

  const convertUrlToFile = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const timestamp = new Date().getTime();
    return new File([blob], `profile_${realtorCode}_${timestamp}.jpg`, {
      type: blob.type,
    });
  };

  const convertUrlToFileLogo = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const timestamp = new Date().getTime();
    return new File([blob], `brokerage_logo_${realtorCode}_${timestamp}.jpg`, {
      type: blob.type,
    });
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);

      if (!croppedAreaPixels || !profilePic) {
        toast.error("Please select an area to crop");
        return;
      }

      const croppedImageBlob = await getCroppedImg(
        profilePic,
        croppedAreaPixels
      );

      // Create a File object from the blob
      const timestamp = new Date().getTime();
      const croppedImageFile = new File(
        [croppedImageBlob],
        `profile_${realtorCode}_${timestamp}.jpg`,
        { type: "image/jpeg" }
      );

      // Update the state with cropped image
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePic(reader.result);
        setImageFile(croppedImageFile);
        setShowCropModal(false);
        setIsSaving(false);
      };
      reader.readAsDataURL(croppedImageFile);
    } catch (error) {
      console.error("Error cropping image:", error);
      toast.error("Error cropping image");
      setIsSaving(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const newErrors = {};
    Object.keys(formData).forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) {
        newErrors[field] = error;
      }
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please correct the errors before submitting.");
      setIsSubmitting(false);
      return;
    }

    const finaldata = new FormData();
    finaldata.append("role_id", roleId);
    finaldata.append("first_name", formData.firstName);
    finaldata.append("last_name", formData.lastName);
    finaldata.append("phone_number", formData.phoneNumber);
    finaldata.append("address", formData.address);
    finaldata.append("state", formData.state);
    finaldata.append("city", formData.city);
    finaldata.append("zipcode", formData.zipcode);
    finaldata.append("brokerage_name", formData.brokerageName);
    finaldata.append(
      "real_estate_website_url",
      formData.real_estate_website_url
    );
    finaldata.append("about_me_url", formData.about_me);
    finaldata.append("instagram_profile_url", formData.instagram || "");
    finaldata.append("youtube_profile_url", formData.youtube || "");
    finaldata.append("facebook_profile_url", formData.facebook || "");
    finaldata.append("linkedin_profile_url", formData.linkedin || "");
    finaldata.append("tiktok_profile_url", formData.tiktok || "");
    finaldata.append("twitter_profile_url", formData.twitter || "");

    // Profile Picture Handling
    if (profilePic?.startsWith("https")) {
      try {
        const file = await convertUrlToFile(profilePic);
        finaldata.append("image", file);
      } catch (err) {
        console.error("Error converting URL to file:", err);
      }
    } else if (imageFile instanceof File) {
      finaldata.append("image", imageFile);
    }

    if (logoFile instanceof File) {
      finaldata.append("brokerage_logo", logoFile);
    } else if (logo?.startsWith("https")) {
      try {
        const file = await convertUrlToFileLogo(logo); // Convert URL to File
        finaldata.append("brokerage_logo", file);
      } catch (err) {
        console.error("Error converting URL to file:", err);
      }
    } else if (profile?.brokerage_logo?.startsWith("https")) {
      try {
        const file = await convertUrlToFileLogo(profile.brokerage_logo); // Convert Profile URL to File
        finaldata.append("brokerage_logo", file);
      } catch (err) {
        console.error("Error converting URL to file:", err);
      }
    }

    // Dispatch API Call
    dispatch(
      updateProfileApi({
        profileId: profile.id,
        formData: finaldata,
      })
    )
      .unwrap()
      .then((res) => {
        toast.success("Profile Updated successfully!");
        dispatch(realtorWebcardApi(realtorCode));
        localStorage.setItem("user_first_name", res?.data?.first_name);
        localStorage.setItem("user_last_name", res?.data?.last_name);
        props.onHide();
        setIsSubmitting(false);
      })
      .catch((err) => {
        toast.error("Profile Updation failed!");
        props.onHide();
        setIsSubmitting(false);
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Edit WebCard Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <form>
            <div className="d-flex justify-content-between mb-4 mx-4">
              <div className="profile-picture-block text-center mb-5">
                <div className="image-container image-container-profile">
                  <img
                    src={
                      isClicked
                        ? profilePic
                        : formData.image || defaultProfilePic
                    }
                    alt="Profile"
                    className="logo"
                  />
                  <label className="edit-icon" aria-label="Edit Image">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      width={32}
                      height={32}
                    >
                      <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
                      <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
                    </svg>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={updateProfilePic}
                      style={{ display: "none" }}
                    />
                  </label>
                </div>
              </div>
              <div className="logo-share-blk">
                <div className="profile-pic-container webcard-logo-image">
                  <img
                    src={
                      isLogoClicked
                        ? logo
                        : formData.brokerageLogo || defaultProfilePic
                    }
                    alt="Logo"
                    // className="profile-pic"
                    id="logo"
                  />
                  <div
                    className="edit-icon"
                    onClick={() =>
                      document.getElementById("logoFileInput").click()
                    }
                  >
                    <i className="fa fa-pencil"></i>
                  </div>
                  <input
                    type="file"
                    id="logoFileInput"
                    className="file-input"
                    accept="image/*"
                    onChange={updateLogo}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <label htmlFor="firstName" className="form-label">
                  First Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.firstName ? "is-invalid" : ""
                  }`}
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.firstName}</div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="lastName" className="form-label">
                  Last Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.lastName ? "is-invalid" : ""
                  }`}
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.lastName}</div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="phoneNumber" className="form-label">
                  Phone Number<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.phoneNumber ? "is-invalid" : ""
                  }`}
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handlePhoneNumberChange}
                />
                <div className="invalid-feedback">{errors.phoneNumber}</div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="address" className="form-label">
                  Address<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.address ? "is-invalid" : ""
                  }`}
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.address}</div>
              </div>
              <div className="col-md-6 mb-3 community-city-blk">
                <label htmlFor="state" className="form-label">
                  State<span className="text-danger">*</span>
                </label>
                <div className="city-name-blk">
                  <select
                    id="state"
                    name="state"
                    className="dropdown-box webcard-edit-dropdown"
                    value={formData.state}
                    onChange={handleStateChange}
                  >
                    <option value="" disabled selected>
                      Select state
                    </option>
                    {states.map((state) => (
                      <option key={state.id} value={state.isoCode}>
                        {" "}
                        {state.name}
                      </option>
                    ))}
                  </select>
                  {errors.state && (
                    <div className="error-text">{errors.state}</div>
                  )}
                </div>
                <div className="invalid-feedback">{errors.state}</div>
              </div>
              <div className="col-md-6 mb-3 community-city-blk">
                <label htmlFor="firstName" className="form-label">
                  City
                </label>
                <div className="city-name-blk">
                  <select
                    id="city"
                    name="city"
                    className="dropdown-box webcard-edit-dropdown"
                    value={formData.city}
                    onChange={handleCityChange}
                  >
                    <option value="" disabled selected>
                      Select city
                    </option>
                    {cities.map((city) => (
                      <option key={city.id} value={city.isoCode}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="lastName" className="form-label">
                  Brokerage Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.brokerageName ? "is-invalid" : ""
                  }`}
                  id="brokerage_name"
                  name="brokerageName"
                  value={formData.brokerageName}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.brokerageName}</div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="lastName" className="form-label">
                  Real Estate Website<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.real_estate_website_url ? "is-invalid" : ""
                  }`}
                  id="real_estate_website_url"
                  name="real_estate_website_url"
                  value={formData.real_estate_website_url}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">
                  {errors.real_estate_website_url}
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="youtube" className="form-label">
                  About Me(URL)
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.about_me ? "is-invalid" : ""
                  }`}
                  id="about_me"
                  name="about_me"
                  value={formData.about_me}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.about_me}</div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="youtube" className="form-label">
                  Youtube
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.youtube ? "is-invalid" : ""
                  }`}
                  id="youtube"
                  name="youtube"
                  value={formData.youtube}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.youtube}</div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="facebook" className="form-label">
                  Facebook
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.facebook ? "is-invalid" : ""
                  }`}
                  id="facebook"
                  name="facebook"
                  value={formData.facebook}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.facebook}</div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="instagram" className="form-label">
                  Instagram
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.instagram ? "is-invalid" : ""
                  }`}
                  id="instagram"
                  name="instagram"
                  value={formData.instagram}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.instagram}</div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="tiktok" className="form-label">
                  TikTok
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.tiktok ? "is-invalid" : ""
                  }`}
                  id="tiktok"
                  name="tiktok"
                  value={formData.tiktok}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.tiktok}</div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="linkedin" className="form-label">
                  LinkedIn
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.linkedin ? "is-invalid" : ""
                  }`}
                  id="linkedin"
                  name="linkedin"
                  value={formData.linkedin}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.linkedin}</div>
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="twitter" className="form-label">
                  Twitter
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.twitter ? "is-invalid" : ""
                  }`}
                  id="twitter"
                  name="twitter"
                  value={formData.twitter}
                  onChange={handleChange}
                />
                <div className="invalid-feedback">{errors.twitter}</div>
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={props.onHide} className="bttn-close">
          Close
        </button>
        <button
          onClick={handleSubmit}
          className="bttn-upload"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting" : "Submit"}
        </button>
      </Modal.Footer>
      <Modal show={showCropModal} onHide={handleCloseCropModal}>
        <Modal.Header closeButton>
          <Modal.Title>Crop Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ position: "relative", width: "100%", height: "300px" }}>
            {profilePic && (
              <ReactCrop
                image={profilePic}
                crop={crop}
                zoom={zoom}
                minWidth={400}
                minHeight={400}
                aspect={1}
                cropShape="round"
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={(croppedArea, croppedAreaPixels) => {
                  setCroppedAreaPixels(croppedAreaPixels);
                }}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="bttn-close" onClick={handleCloseCropModal}>
            Close
          </button>
          <button
            className="bttn-upload"
            onClick={handleSave}
            disabled={isSaving || !croppedAreaPixels}
          >
            Save Cropped Image
          </button>
        </Modal.Footer>
      </Modal>
    </Modal>
  );
}

function ServiceProvidersModal(props) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const userId = localStorage.getItem("user_id");
  const vendors = useSelector((state) => state.getVendorsByType.data);
  useEffect(() => {
    dispatch(
      getVendorsByType({
        vendor_master_name: "community_expert",
        realtor_code: id,
        user_id: userId,
      })
    );
  }, [dispatch, id, userId]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Real Estate Service Providers
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className="tab-group">
          <div className="inner-wrapper-box">
            <div className="lower-block">
              <div className="tab-content">
                <div className="community-box d-flex flex-column">
                  {vendors?.vendor
                    ?.filter((real) => real?.name !== null && real?.name !== "")
                    ?.map((real, index) => (
                      <div
                        className="community-expert-block d-flex justify-content-between align-items-center"
                        key={real?.id}
                      >
                        <div className="d-flex expert-inner-block align-items-center">
                          <div className="experts-img">
                            <img
                              src={real?.vendor_image || community_icon}
                              alt="profile-photo"
                            ></img>
                          </div>
                          <div className="expert-content">
                            <div>
                              <span>{real?.sub_vendor_type}</span> |{" "}
                              {real?.name}
                            </div>
                            <div className="expert-address">
                              {real?.address?.replace(", USA", "")}{" "}
                              {real?.mobile
                                ? `| ${real?.mobile?.replace("+1 ", "")}`
                                : ""}
                            </div>
                          </div>
                        </div>
                        <div className="contact-icons d-flex align-items-center">
                          <div className="small-icon-blk">
                            {real?.mobile ? (
                              <div className="phone-no vendor-tab">
                                <a href={`tel:${real?.mobile}`}>
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M3.26036 10.6357C4.83848 12.5222 6.73818 14.0075 8.90644 15.0584C9.73197 15.4496 10.836 15.9138 12.066 15.9934C12.1422 15.9967 12.2152 16 12.2914 16C13.117 16 13.78 15.7149 14.3204 15.1281C14.3238 15.1247 14.3304 15.1181 14.3337 15.1115C14.526 14.8794 14.7448 14.6705 14.9736 14.4484C15.1294 14.2992 15.2885 14.1434 15.441 13.9843C16.1472 13.2482 16.1472 12.3133 15.4344 11.6005L13.4419 9.60796C13.1037 9.25653 12.6992 9.07087 12.2749 9.07087C11.8505 9.07087 11.4427 9.25653 11.0946 9.60464L9.90768 10.7915C9.79828 10.7286 9.68555 10.6722 9.57946 10.6191C9.44685 10.5528 9.32418 10.4898 9.21477 10.4202C8.13396 9.73394 7.15261 8.83879 6.21436 7.68835C5.74026 7.08827 5.42198 6.58433 5.19985 6.07045C5.5115 5.78864 5.80325 5.49358 6.08506 5.20514C6.18452 5.10236 6.28729 4.99959 6.39007 4.89681C6.74813 4.53875 6.94042 4.12433 6.94042 3.70327C6.94042 3.28222 6.75145 2.8678 6.39007 2.50974L5.40209 1.52176C5.28605 1.40572 5.17664 1.293 5.06392 1.17696C4.84511 0.951513 4.61634 0.719436 4.3909 0.510568C4.04942 0.175715 3.64826 0 3.22389 0C2.80284 0 2.39836 0.175715 2.04361 0.513883L0.803664 1.75383C0.352773 2.20472 0.0974891 2.75176 0.0444431 3.385C-0.0185491 4.17737 0.127327 5.01948 0.50528 6.0373C1.08547 7.6121 1.96073 9.07418 3.26036 10.6357ZM0.853395 3.45462C0.893179 3.01368 1.06226 2.64567 1.38054 2.32739L2.61386 1.09407C2.80615 0.908413 3.01833 0.812267 3.22389 0.812267C3.42613 0.812267 3.63168 0.908413 3.82066 1.1007C4.04279 1.30626 4.25165 1.52176 4.4771 1.75052C4.58982 1.86656 4.70586 1.98259 4.8219 2.10195L5.80988 3.08993C6.01543 3.29548 6.12153 3.50435 6.12153 3.7099C6.12153 3.91546 6.01543 4.12433 5.80988 4.32988C5.7071 4.43266 5.60433 4.53875 5.50155 4.64152C5.19322 4.95317 4.90478 5.24824 4.58651 5.53005L4.56993 5.54662C4.29475 5.8218 4.33785 6.08371 4.40416 6.28264C4.40748 6.29258 4.41079 6.29921 4.41411 6.30916C4.66939 6.9225 5.02414 7.50601 5.5778 8.20224C6.57242 9.42893 7.62007 10.3804 8.77383 11.1131C8.91639 11.206 9.06889 11.2789 9.21145 11.3518C9.34407 11.4182 9.46674 11.4811 9.57615 11.5508C9.58941 11.5574 9.59935 11.564 9.61261 11.5707C9.72202 11.627 9.82811 11.6535 9.93421 11.6535C10.1994 11.6535 10.3718 11.4845 10.4282 11.4281L11.6681 10.1881C11.8604 9.99586 12.0693 9.89308 12.2749 9.89308C12.5268 9.89308 12.7324 10.0489 12.8617 10.1881L14.8609 12.184C15.2587 12.5818 15.2554 13.0128 14.8509 13.4339C14.7117 13.5831 14.5658 13.7257 14.41 13.8748C14.1779 14.1003 13.9359 14.3324 13.717 14.5943C13.3358 15.0054 12.8816 15.1977 12.2948 15.1977C12.2384 15.1977 12.1787 15.1944 12.1224 15.191C11.0349 15.1214 10.0237 14.6971 9.2645 14.3357C7.20234 13.3378 5.39214 11.9221 3.89028 10.1252C2.65364 8.63655 1.82148 7.25072 1.27113 5.76544C0.929648 4.85371 0.800349 4.12101 0.853395 3.45462Z"
                                      fill="#414141"
                                    />
                                  </svg>
                                </a>
                              </div>
                            ) : (
                              <div className="phone-no vendor-tab phone-disabled">
                                <a>
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M3.26036 10.6357C4.83848 12.5222 6.73818 14.0075 8.90644 15.0584C9.73197 15.4496 10.836 15.9138 12.066 15.9934C12.1422 15.9967 12.2152 16 12.2914 16C13.117 16 13.78 15.7149 14.3204 15.1281C14.3238 15.1247 14.3304 15.1181 14.3337 15.1115C14.526 14.8794 14.7448 14.6705 14.9736 14.4484C15.1294 14.2992 15.2885 14.1434 15.441 13.9843C16.1472 13.2482 16.1472 12.3133 15.4344 11.6005L13.4419 9.60796C13.1037 9.25653 12.6992 9.07087 12.2749 9.07087C11.8505 9.07087 11.4427 9.25653 11.0946 9.60464L9.90768 10.7915C9.79828 10.7286 9.68555 10.6722 9.57946 10.6191C9.44685 10.5528 9.32418 10.4898 9.21477 10.4202C8.13396 9.73394 7.15261 8.83879 6.21436 7.68835C5.74026 7.08827 5.42198 6.58433 5.19985 6.07045C5.5115 5.78864 5.80325 5.49358 6.08506 5.20514C6.18452 5.10236 6.28729 4.99959 6.39007 4.89681C6.74813 4.53875 6.94042 4.12433 6.94042 3.70327C6.94042 3.28222 6.75145 2.8678 6.39007 2.50974L5.40209 1.52176C5.28605 1.40572 5.17664 1.293 5.06392 1.17696C4.84511 0.951513 4.61634 0.719436 4.3909 0.510568C4.04942 0.175715 3.64826 0 3.22389 0C2.80284 0 2.39836 0.175715 2.04361 0.513883L0.803664 1.75383C0.352773 2.20472 0.0974891 2.75176 0.0444431 3.385C-0.0185491 4.17737 0.127327 5.01948 0.50528 6.0373C1.08547 7.6121 1.96073 9.07418 3.26036 10.6357ZM0.853395 3.45462C0.893179 3.01368 1.06226 2.64567 1.38054 2.32739L2.61386 1.09407C2.80615 0.908413 3.01833 0.812267 3.22389 0.812267C3.42613 0.812267 3.63168 0.908413 3.82066 1.1007C4.04279 1.30626 4.25165 1.52176 4.4771 1.75052C4.58982 1.86656 4.70586 1.98259 4.8219 2.10195L5.80988 3.08993C6.01543 3.29548 6.12153 3.50435 6.12153 3.7099C6.12153 3.91546 6.01543 4.12433 5.80988 4.32988C5.7071 4.43266 5.60433 4.53875 5.50155 4.64152C5.19322 4.95317 4.90478 5.24824 4.58651 5.53005L4.56993 5.54662C4.29475 5.8218 4.33785 6.08371 4.40416 6.28264C4.40748 6.29258 4.41079 6.29921 4.41411 6.30916C4.66939 6.9225 5.02414 7.50601 5.5778 8.20224C6.57242 9.42893 7.62007 10.3804 8.77383 11.1131C8.91639 11.206 9.06889 11.2789 9.21145 11.3518C9.34407 11.4182 9.46674 11.4811 9.57615 11.5508C9.58941 11.5574 9.59935 11.564 9.61261 11.5707C9.72202 11.627 9.82811 11.6535 9.93421 11.6535C10.1994 11.6535 10.3718 11.4845 10.4282 11.4281L11.6681 10.1881C11.8604 9.99586 12.0693 9.89308 12.2749 9.89308C12.5268 9.89308 12.7324 10.0489 12.8617 10.1881L14.8609 12.184C15.2587 12.5818 15.2554 13.0128 14.8509 13.4339C14.7117 13.5831 14.5658 13.7257 14.41 13.8748C14.1779 14.1003 13.9359 14.3324 13.717 14.5943C13.3358 15.0054 12.8816 15.1977 12.2948 15.1977C12.2384 15.1977 12.1787 15.1944 12.1224 15.191C11.0349 15.1214 10.0237 14.6971 9.2645 14.3357C7.20234 13.3378 5.39214 11.9221 3.89028 10.1252C2.65364 8.63655 1.82148 7.25072 1.27113 5.76544C0.929648 4.85371 0.800349 4.12101 0.853395 3.45462Z"
                                      fill="#414141"
                                    />
                                  </svg>
                                </a>
                              </div>
                            )}
                            {real?.email ? (
                              <div className="msgs vendor-tab">
                                <a href={`mailto:${real?.email}`}>
                                  <svg
                                    width="16"
                                    height="12"
                                    viewBox="0 0 16 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M15.1795 0.666504H0.820531C0.369219 0.666504 0 1.03572 0 1.487V10.5127C0 10.9639 0.369219 11.3332 0.820531 11.3332H15.1795C15.6307 11.3332 16 10.964 16 10.5127V1.487C16 1.03572 15.6308 0.666504 15.1795 0.666504ZM14.8716 1.28185L8.472 6.08191C8.35694 6.16947 8.18031 6.22425 7.99997 6.22344C7.81966 6.22425 7.64306 6.16947 7.52797 6.08191L1.12841 1.28185H14.8716ZM11.4531 6.39863L14.9403 10.7063C14.9438 10.7107 14.9481 10.7139 14.9518 10.7178H1.04819C1.05187 10.7138 1.05619 10.7107 1.05969 10.7063L4.54688 6.39863C4.5723 6.36721 4.59129 6.33109 4.60275 6.29233C4.61422 6.25356 4.61793 6.21292 4.61368 6.17273C4.60943 6.13253 4.5973 6.09357 4.57799 6.05806C4.55868 6.02255 4.53256 5.9912 4.50112 5.96579C4.36903 5.85894 4.17537 5.87919 4.0685 6.01132L0.615375 10.277V1.66647L7.15894 6.57416C7.40491 6.75735 7.70416 6.83797 7.99994 6.83879C8.29531 6.83816 8.59481 6.75753 8.84094 6.57416L15.3845 1.66647V10.2769L11.9315 6.01132C11.8246 5.87922 11.6308 5.85891 11.4988 5.96579C11.3665 6.07263 11.3462 6.26653 11.4531 6.39863Z"
                                      fill="#414141"
                                    />
                                  </svg>
                                </a>
                              </div>
                            ) : (
                              <div className="msgs vendor-tab msgs-disabled">
                                <a>
                                  <svg
                                    width="16"
                                    height="12"
                                    viewBox="0 0 16 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M15.1795 0.666504H0.820531C0.369219 0.666504 0 1.03572 0 1.487V10.5127C0 10.9639 0.369219 11.3332 0.820531 11.3332H15.1795C15.6307 11.3332 16 10.964 16 10.5127V1.487C16 1.03572 15.6308 0.666504 15.1795 0.666504ZM14.8716 1.28185L8.472 6.08191C8.35694 6.16947 8.18031 6.22425 7.99997 6.22344C7.81966 6.22425 7.64306 6.16947 7.52797 6.08191L1.12841 1.28185H14.8716ZM11.4531 6.39863L14.9403 10.7063C14.9438 10.7107 14.9481 10.7139 14.9518 10.7178H1.04819C1.05187 10.7138 1.05619 10.7107 1.05969 10.7063L4.54688 6.39863C4.5723 6.36721 4.59129 6.33109 4.60275 6.29233C4.61422 6.25356 4.61793 6.21292 4.61368 6.17273C4.60943 6.13253 4.5973 6.09357 4.57799 6.05806C4.55868 6.02255 4.53256 5.9912 4.50112 5.96579C4.36903 5.85894 4.17537 5.87919 4.0685 6.01132L0.615375 10.277V1.66647L7.15894 6.57416C7.40491 6.75735 7.70416 6.83797 7.99994 6.83879C8.29531 6.83816 8.59481 6.75753 8.84094 6.57416L15.3845 1.66647V10.2769L11.9315 6.01132C11.8246 5.87922 11.6308 5.85891 11.4988 5.96579C11.3665 6.07263 11.3462 6.26653 11.4531 6.39863Z"
                                      fill="#414141"
                                    />
                                  </svg>
                                </a>
                              </div>
                            )}
                            {real?.website ? (
                              <div className="globe vendor-tab">
                                <a
                                  href={real?.website}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8 0C4.62047 0 0 2.55433 0 8C0 13.3071 4.44409 16 8 16C14.1008 16 16 10.6551 16 8C16 4.08189 13.0016 0 8 0ZM6.14488 0.752756C5.31024 1.46457 4.61732 2.64252 4.17008 4.10394C3.59055 3.76063 3.05827 3.33543 2.58583 2.84094C3.5622 1.81732 4.79685 1.09921 6.14488 0.752756ZM2.24252 3.2252C2.77165 3.77638 3.37323 4.24567 4.02835 4.61732C3.78268 5.57165 3.6378 6.62992 3.6189 7.74173H0.522835C0.579528 6.08189 1.18425 4.49764 2.24252 3.2252ZM2.24252 12.7748C1.1811 11.5024 0.579528 9.91811 0.522835 8.25827H3.6189C3.6378 9.37323 3.78268 10.4283 4.02835 11.3827C3.37638 11.7575 2.7748 12.2236 2.24252 12.7748ZM2.58583 13.1622C3.05827 12.6677 3.59055 12.2425 4.17008 11.8992C4.61732 13.3575 5.31024 14.5386 6.14488 15.2504C4.79685 14.9008 3.5622 14.1827 2.58583 13.1622ZM7.74173 15.4646C6.4 15.2945 5.24409 13.7953 4.62047 11.6472C5.58425 11.1591 6.64882 10.885 7.74173 10.8441V15.4646ZM7.74173 10.3307C6.60157 10.3685 5.49291 10.6488 4.48819 11.1402C4.27717 10.2583 4.15118 9.28504 4.13228 8.25827H7.74173V10.3307ZM7.74173 7.74173H4.13228C4.15118 6.71496 4.27717 5.74173 4.48819 4.85984C5.49606 5.35118 6.60472 5.6315 7.74173 5.66929V7.74173ZM7.74173 5.15591C6.64567 5.11811 5.58425 4.84094 4.62047 4.35276C5.24409 2.20157 6.4 0.705512 7.74173 0.535433V5.15591ZM13.7575 3.2252C14.8157 4.49764 15.4205 6.08189 15.4772 7.74173H12.3843C12.3654 6.62677 12.2205 5.57165 11.9748 4.61732C12.6268 4.24252 13.2283 3.77638 13.7575 3.2252ZM13.4142 2.8378C12.9417 3.33228 12.4094 3.75748 11.8299 4.10079C11.3827 2.64252 10.6898 1.46457 9.85512 0.749606C11.2031 1.09921 12.4378 1.81732 13.4142 2.8378ZM8.25827 0.535433C9.6 0.705512 10.7559 2.20472 11.3795 4.35276C10.4157 4.84094 9.35433 5.11496 8.25827 5.15591V0.535433ZM8.25827 5.66929C9.39843 5.6315 10.5071 5.35118 11.5118 4.85984C11.7228 5.74173 11.8488 6.71496 11.8677 7.74173H8.25827V5.66929ZM8.25827 8.25827H11.8677C11.8488 9.28504 11.7228 10.2583 11.5118 11.1402C10.4976 10.6411 9.38815 10.365 8.25827 10.3307V8.25827ZM8.25827 15.4646V10.8441C9.35433 10.8819 10.4157 11.1591 11.3795 11.6472C10.7559 13.7984 9.6 15.2945 8.25827 15.4646ZM9.85512 15.2472C10.6898 14.5354 11.3827 13.3575 11.8299 11.8961C12.4094 12.2394 12.9417 12.6646 13.4142 13.1591C12.4378 14.1827 11.2031 14.9008 9.85512 15.2472ZM13.7575 12.7748C13.2283 12.2236 12.6268 11.7575 11.9748 11.3827C12.2205 10.4283 12.3654 9.37008 12.3843 8.25827H15.4772C15.4205 9.91811 14.8157 11.5024 13.7575 12.7748Z"
                                      fill="#414141"
                                    />
                                  </svg>
                                </a>
                              </div>
                            ) : (
                              <div className="globe vendor-tab globe-disabled">
                                <a>
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8 0C4.62047 0 0 2.55433 0 8C0 13.3071 4.44409 16 8 16C14.1008 16 16 10.6551 16 8C16 4.08189 13.0016 0 8 0ZM6.14488 0.752756C5.31024 1.46457 4.61732 2.64252 4.17008 4.10394C3.59055 3.76063 3.05827 3.33543 2.58583 2.84094C3.5622 1.81732 4.79685 1.09921 6.14488 0.752756ZM2.24252 3.2252C2.77165 3.77638 3.37323 4.24567 4.02835 4.61732C3.78268 5.57165 3.6378 6.62992 3.6189 7.74173H0.522835C0.579528 6.08189 1.18425 4.49764 2.24252 3.2252ZM2.24252 12.7748C1.1811 11.5024 0.579528 9.91811 0.522835 8.25827H3.6189C3.6378 9.37323 3.78268 10.4283 4.02835 11.3827C3.37638 11.7575 2.7748 12.2236 2.24252 12.7748ZM2.58583 13.1622C3.05827 12.6677 3.59055 12.2425 4.17008 11.8992C4.61732 13.3575 5.31024 14.5386 6.14488 15.2504C4.79685 14.9008 3.5622 14.1827 2.58583 13.1622ZM7.74173 15.4646C6.4 15.2945 5.24409 13.7953 4.62047 11.6472C5.58425 11.1591 6.64882 10.885 7.74173 10.8441V15.4646ZM7.74173 10.3307C6.60157 10.3685 5.49291 10.6488 4.48819 11.1402C4.27717 10.2583 4.15118 9.28504 4.13228 8.25827H7.74173V10.3307ZM7.74173 7.74173H4.13228C4.15118 6.71496 4.27717 5.74173 4.48819 4.85984C5.49606 5.35118 6.60472 5.6315 7.74173 5.66929V7.74173ZM7.74173 5.15591C6.64567 5.11811 5.58425 4.84094 4.62047 4.35276C5.24409 2.20157 6.4 0.705512 7.74173 0.535433V5.15591ZM13.7575 3.2252C14.8157 4.49764 15.4205 6.08189 15.4772 7.74173H12.3843C12.3654 6.62677 12.2205 5.57165 11.9748 4.61732C12.6268 4.24252 13.2283 3.77638 13.7575 3.2252ZM13.4142 2.8378C12.9417 3.33228 12.4094 3.75748 11.8299 4.10079C11.3827 2.64252 10.6898 1.46457 9.85512 0.749606C11.2031 1.09921 12.4378 1.81732 13.4142 2.8378ZM8.25827 0.535433C9.6 0.705512 10.7559 2.20472 11.3795 4.35276C10.4157 4.84094 9.35433 5.11496 8.25827 5.15591V0.535433ZM8.25827 5.66929C9.39843 5.6315 10.5071 5.35118 11.5118 4.85984C11.7228 5.74173 11.8488 6.71496 11.8677 7.74173H8.25827V5.66929ZM8.25827 8.25827H11.8677C11.8488 9.28504 11.7228 10.2583 11.5118 11.1402C10.4976 10.6411 9.38815 10.365 8.25827 10.3307V8.25827ZM8.25827 15.4646V10.8441C9.35433 10.8819 10.4157 11.1591 11.3795 11.6472C10.7559 13.7984 9.6 15.2945 8.25827 15.4646ZM9.85512 15.2472C10.6898 14.5354 11.3827 13.3575 11.8299 11.8961C12.4094 12.2394 12.9417 12.6646 13.4142 13.1591C12.4378 14.1827 11.2031 14.9008 9.85512 15.2472ZM13.7575 12.7748C13.2283 12.2236 12.6268 11.7575 11.9748 11.3827C12.2205 10.4283 12.3654 9.37008 12.3843 8.25827H15.4772C15.4205 9.91811 14.8157 11.5024 13.7575 12.7748Z"
                                      fill="#414141"
                                    />
                                  </svg>
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={props.onHide} className="bttn-close">
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default Webcard;
